import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1254.000000 1254.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)" >


<path d="M6938 11843 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6950 11810 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10
-5 0 -3 -5 5 -10z"/>
<path d="M7086 11771 c-3 -5 3 -11 13 -14 14 -3 18 -1 14 9 -6 16 -19 18 -27
5z"/>
<path d="M7164 11746 c-4 -10 -17 -13 -47 -9 -46 5 -47 7 27 -50 33 -25 69
-55 135 -112 l46 -40 98 9 c95 10 133 26 60 26 -24 0 -33 3 -25 8 9 7 6 14
-14 28 -15 10 -35 27 -46 37 -10 9 -22 17 -28 17 -5 0 -10 4 -10 9 0 5 -21 17
-47 27 -27 10 -55 23 -64 31 -18 15 -45 17 -54 3 -3 -5 -12 -10 -18 -10 -7 0
-4 5 6 11 9 5 17 14 17 19 0 15 -30 12 -36 -4z"/>
<path d="M6605 11713 c11 -18 25 -35 32 -37 19 -8 1 24 -28 49 l-22 20 18 -32z"/>
<path d="M6666 11715 c29 -29 46 -31 65 -8 13 15 11 16 -10 10 -14 -3 -29 0
-38 9 -8 8 -21 14 -28 14 -9 0 -5 -9 11 -25z"/>
<path d="M6760 11693 c0 -3 12 -25 26 -49 33 -57 26 -67 -10 -15 -15 22 -33
42 -40 44 -20 8 -47 -18 -40 -39 6 -16 5 -17 -7 -6 -17 16 -29 15 -29 -2 0 -7
-10 -16 -22 -19 -12 -4 -20 -8 -18 -11 14 -13 195 -84 202 -79 5 3 7 16 4 28
-9 36 11 39 23 3 10 -29 12 -30 29 -16 9 9 32 25 50 36 l33 20 -46 37 c-43 36
-46 37 -65 20 -10 -9 -24 -14 -29 -10 -16 9 -13 25 4 25 23 0 18 17 -7 25 -30
9 -58 13 -58 8z m-30 -108 c0 -5 -5 -3 -10 5 -5 8 -10 20 -10 25 0 6 5 3 10
-5 5 -8 10 -19 10 -25z"/>
<path d="M7040 11652 c0 -4 9 -13 20 -20 11 -7 20 -9 20 -4 0 4 -9 13 -20 20
-11 7 -20 9 -20 4z"/>
<path d="M7121 11619 c1 -8 28 -39 61 -69 47 -43 61 -51 68 -40 6 10 2 17 -19
26 -15 6 -38 24 -52 40 -37 44 -59 60 -58 43z"/>
<path d="M6960 11612 c0 -12 19 -26 26 -19 2 2 -2 10 -11 17 -9 8 -15 8 -15 2z"/>
<path d="M6465 11578 c-8 -39 -23 -133 -21 -135 3 -4 71 31 77 40 4 5 12 8 18
6 7 -3 -6 -18 -28 -34 -22 -17 -41 -33 -41 -36 0 -4 52 -32 116 -64 63 -31
113 -59 111 -62 -3 -2 -29 8 -58 23 -78 39 -179 75 -179 64 0 -6 22 -59 49
-118 27 -60 51 -124 55 -143 6 -32 5 -32 -5 -9 -102 220 -124 260 -136 243 -7
-9 -13 -22 -13 -27 0 -6 4 -4 10 4 11 18 17 13 23 -20 2 -14 2 -19 0 -12 -10
29 -23 9 -18 -28 4 -32 0 -48 -16 -70 -16 -21 -20 -37 -16 -59 5 -23 3 -31 -8
-31 -18 0 -20 -16 -2 -24 6 -3 30 -17 52 -30 56 -35 116 -67 144 -77 22 -9 23
-8 17 23 l-6 33 19 -24 c11 -14 23 -21 30 -17 13 8 63 -38 53 -48 -3 -3 3 -6
14 -7 10 0 13 -3 7 -6 -14 -5 -18 -33 -5 -33 4 -1 21 -12 37 -26 l30 -26 -43
22 c-46 22 -63 21 -43 -4 7 -8 8 -17 3 -20 -6 -3 -12 1 -16 9 -10 26 -26 16
-26 -15 0 -16 4 -30 9 -30 5 0 11 -7 15 -15 6 -16 -14 -16 -27 0 -5 6 -6 2 -3
-9 4 -12 0 -23 -11 -31 -16 -12 -15 -14 12 -20 47 -10 55 -14 55 -23 0 -5 -21
-8 -47 -8 -51 1 -70 -18 -28 -28 24 -6 36 -26 15 -26 -5 0 -10 -8 -10 -17 0
-13 -5 -11 -19 10 -14 22 -20 25 -24 13 -3 -8 -1 -17 6 -19 9 -3 9 -8 0 -18
-11 -11 -13 -11 -13 0 0 8 -6 11 -16 7 -11 -4 -14 -1 -9 13 4 13 -1 21 -17 26
l-23 8 22 4 c27 5 50 30 28 30 -8 0 -12 -4 -9 -9 3 -4 -2 -8 -10 -8 -9 0 -20
16 -27 40 -13 42 -41 58 -32 18 l6 -23 -21 20 c-12 12 -23 38 -26 63 -3 23 -8
47 -11 52 -9 15 38 58 84 76 23 9 41 19 41 23 0 4 -12 14 -27 21 -16 8 -35 19
-43 25 -32 25 -111 48 -123 36 -7 -7 -7 -11 -1 -11 6 0 8 -17 6 -37 -4 -40
-31 -103 -44 -103 -5 0 -8 -11 -8 -25 0 -16 -6 -25 -15 -25 -9 0 -24 -14 -33
-30 -9 -17 -22 -28 -28 -26 -6 2 -11 -2 -11 -9 0 -15 77 0 88 17 4 6 13 8 20
6 7 -2 -17 -19 -54 -38 -37 -18 -67 -36 -67 -39 0 -3 25 -21 56 -40 30 -18 53
-35 51 -37 -3 -3 -28 9 -56 26 -29 16 -59 30 -68 30 -17 0 -17 -1 22 -104 14
-38 24 -71 21 -73 -2 -2 -10 13 -16 34 -7 21 -24 57 -37 81 -21 35 -28 40 -39
31 -20 -17 -31 -2 -16 21 7 11 8 20 4 20 -5 0 -26 -34 -48 -75 -39 -76 -69
-114 -81 -102 -3 4 -1 7 5 7 17 0 69 101 77 150 4 31 3 41 -4 30 -5 -8 -7 -18
-4 -23 3 -5 -4 -6 -16 -3 -11 3 -29 8 -40 11 -10 3 -39 -4 -65 -15 -57 -24
-57 -24 -50 -5 5 12 -3 15 -39 15 -35 0 -47 4 -51 18 -5 18 2 -63 10 -108 2
-14 -5 2 -16 35 -33 97 -31 93 -40 70 -7 -16 -9 -17 -9 -3 -1 19 -33 54 -80
87 -18 13 -28 27 -24 36 10 28 -39 16 -86 -21 -10 -9 26 -35 60 -44 22 -6 39
-14 39 -18 0 -5 -11 -23 -25 -42 l-25 -34 26 -16 c23 -14 25 -20 21 -63 -3
-37 -1 -50 11 -55 8 -3 46 -29 84 -57 79 -60 106 -63 161 -21 21 16 37 23 37
17 0 -6 -4 -11 -9 -11 -13 0 -71 -50 -71 -61 0 -5 24 -25 54 -44 30 -19 58
-40 61 -46 4 -6 -12 2 -36 16 -56 36 -100 49 -111 32 -6 -9 -8 -9 -8 0 0 7 -6
11 -12 9 -7 -1 -10 -1 -5 1 28 16 -34 81 -137 143 -31 19 -40 20 -47 9 -7 -11
-9 -10 -9 5 0 12 -5 16 -14 13 -8 -3 -30 -9 -50 -12 -42 -8 -70 -37 -63 -65 6
-22 -4 -25 -31 -11 -45 24 -107 38 -97 21 3 -5 14 -10 24 -10 22 0 41 -19 41
-43 0 -10 4 -16 10 -12 5 3 7 12 3 20 -3 8 0 15 7 15 8 0 11 -13 8 -39 -2 -27
0 -37 9 -34 6 3 10 10 7 17 -3 7 5 21 17 32 l22 19 -6 -33 c-4 -21 -3 -31 3
-27 6 3 10 2 10 -4 0 -5 -10 -11 -22 -13 -13 -2 -24 -11 -26 -22 -3 -15 1 -18
22 -14 14 3 26 2 26 -2 0 -13 -26 -19 -41 -9 -8 5 -26 9 -41 9 -17 0 -33 9
-46 27 l-20 27 -31 -33 c-34 -37 -35 -37 -45 -4 -6 18 -4 20 13 16 13 -3 23 0
27 10 3 9 12 13 21 10 11 -4 14 -2 11 8 -3 8 -11 13 -18 11 -9 -2 -10 5 -5 25
11 41 8 63 -10 77 -9 7 -21 34 -27 62 -5 27 -14 67 -20 89 -5 22 -12 52 -15
68 -3 15 -10 30 -15 33 -13 8 -6 -40 21 -156 5 -24 8 -46 6 -49 -7 -7 -54 28
-69 52 -23 35 -49 147 -42 185 3 19 15 46 28 59 21 23 22 24 5 71 -21 57 -21
81 -3 108 14 19 13 20 -25 17 -29 -2 -39 1 -39 11 0 8 5 18 10 21 6 3 10 13
10 22 0 13 -3 13 -15 3 -24 -20 -27 -6 -5 23 22 27 26 52 10 62 -5 3 -10 -2
-10 -12 0 -10 -9 -33 -20 -51 -23 -37 -25 -53 -8 -49 17 3 18 -52 2 -83 -13
-24 -13 -24 -14 18 0 24 -4 41 -9 38 -5 -3 -14 1 -21 9 -15 18 -40 20 -40 3 0
-9 -3 -9 -9 1 -7 11 -11 4 -15 -25 -4 -21 -11 -59 -17 -83 -6 -30 -6 -48 0
-54 7 -7 4 -21 -9 -42 -19 -30 -19 -35 -5 -68 22 -53 17 -68 -7 -23 -18 35
-21 37 -30 22 -7 -13 -7 -21 1 -26 7 -3 14 -24 16 -46 2 -21 2 -30 -1 -19 -13
48 -17 48 -31 0 -8 -27 -16 -65 -18 -83 -2 -18 -8 -38 -14 -46 -6 -7 -7 -17
-3 -21 4 -5 -1 -5 -10 -2 -12 4 -15 2 -11 -9 3 -7 14 -14 25 -14 17 0 18 -2 4
-15 -32 -32 -30 -57 5 -86 19 -15 37 -25 41 -23 5 3 8 -7 8 -23 0 -15 9 -41
20 -58 58 -88 55 -83 27 -53 -14 15 -28 24 -31 21 -3 -4 -6 -38 -6 -77 l-1
-71 -19 24 c-25 29 -25 27 -1 -42 25 -72 17 -74 -14 -3 -13 30 -29 57 -34 61
-14 8 -14 4 3 -36 7 -19 17 -45 20 -59 6 -23 6 -23 -9 3 -24 42 -27 28 -11
-49 16 -78 14 -91 -8 -43 -11 27 -15 30 -15 12 -1 -28 9 -53 21 -53 10 0 81
-51 86 -62 2 -4 10 -4 18 -1 8 3 14 0 14 -6 0 -6 7 -11 16 -11 11 0 14 5 10
16 -3 9 -8 28 -11 42 -4 19 0 15 16 -16 19 -37 25 -42 53 -41 42 2 67 9 62 18
-3 4 0 13 6 21 8 12 9 12 4 -2 -8 -26 4 -28 84 -15 l73 12 -29 25 c-17 14 -34
32 -39 40 -5 8 12 -3 38 -24 l48 -39 55 12 c31 7 58 11 60 8 3 -2 -12 -8 -33
-12 -21 -4 -42 -10 -48 -13 -5 -4 -25 -8 -44 -9 -19 -1 -67 -10 -108 -19 -61
-15 -73 -21 -74 -38 -1 -17 -2 -18 -6 -3 -3 11 -14 17 -35 17 -23 0 -29 -4
-24 -15 3 -9 0 -15 -9 -15 -8 0 -15 5 -15 11 0 11 -86 6 -165 -10 l-40 -9 45
-2 45 -2 -40 -9 c-57 -11 -75 -11 -75 4 0 9 -39 11 -169 9 -183 -4 -335 14
-375 44 -19 15 -20 16 -1 10 102 -36 261 -51 419 -41 l115 7 -22 59 c-16 44
-18 62 -10 70 11 11 29 1 149 -79 33 -21 -69 30 -111 56 -32 20 -37 21 -25 6
17 -21 45 -44 75 -60 11 -5 19 -18 17 -27 -2 -14 4 -16 40 -13 24 3 51 5 61 5
27 1 20 21 -8 21 -14 0 -25 6 -25 13 0 7 -19 23 -42 35 -61 31 -119 64 -148
85 -13 9 -31 17 -40 17 -8 0 3 -11 25 -25 22 -13 36 -24 30 -24 -11 -1 -184
98 -173 99 12 0 63 -24 76 -37 7 -7 18 -13 24 -13 19 0 -22 38 -48 44 -13 4
-24 11 -24 16 0 15 8 12 56 -21 25 -17 47 -29 49 -27 2 1 -6 44 -16 93 -14 65
-20 135 -22 252 -2 137 -4 163 -17 163 -12 1 -11 3 3 11 19 11 23 39 6 39 -22
0 -354 -168 -373 -189 -11 -12 -15 -21 -9 -21 6 0 77 33 159 72 170 83 173 84
159 70 -5 -5 -68 -40 -140 -77 -133 -68 -155 -82 -155 -95 0 -12 67 -80 135
-136 33 -27 69 -57 80 -67 11 -10 33 -25 48 -34 16 -8 27 -17 24 -19 -6 -7
-137 79 -161 105 -11 12 -25 21 -33 21 -7 0 -13 5 -13 12 0 6 -3 9 -6 5 -6 -6
-21 5 -84 61 -21 17 -40 32 -44 32 -4 0 -37 -20 -74 -44 -189 -123 -302 -243
-302 -319 0 -113 112 -170 395 -202 296 -34 649 -5 1080 86 172 37 406 97 540
139 55 17 127 39 160 50 33 10 80 28 105 39 l45 22 -40 -6 c-31 -5 -37 -4 -25
5 19 15 -44 6 -112 -16 -47 -15 -74 -12 -62 7 3 5 13 7 23 4 9 -3 36 4 59 15
22 11 45 20 51 20 5 0 19 12 30 27 20 24 20 27 5 45 -20 21 -19 21 24 9 27 -8
36 -7 53 10 19 19 19 19 19 -2 0 -19 4 -21 43 -17 77 9 353 126 364 155 3 8
-10 29 -32 49 -21 19 -33 34 -28 34 5 0 14 -5 20 -11 6 -6 31 -13 56 -15 36
-3 48 0 67 21 17 18 30 23 49 19 20 -4 23 -3 11 5 -20 13 -2 32 33 34 20 2 23
5 16 19 -5 9 -14 19 -21 21 -10 4 -9 8 2 16 11 7 16 7 19 -2 8 -25 24 -24 46
1 13 15 20 31 17 37 -13 21 -8 45 9 45 12 0 16 -5 13 -14 -8 -21 15 -30 34
-12 29 25 24 53 -16 86 -42 34 -35 41 9 9 16 -11 36 -22 44 -23 8 -1 18 -5 21
-9 12 -12 21 -8 74 34 54 42 54 26 1 -25 -17 -17 -31 -33 -31 -37 0 -9 53 -9
65 1 6 4 17 8 25 8 8 1 43 3 77 6 47 3 78 13 132 42 73 39 75 43 71 105 -1 16
5 29 14 32 19 8 33 -12 16 -23 -7 -4 -9 -16 -5 -29 9 -29 23 -26 17 4 -3 18 0
25 12 25 9 0 16 -7 16 -15 0 -20 6 -19 41 6 23 16 28 26 24 42 -5 16 -4 18 3
8 9 -12 14 -12 36 3 29 19 30 20 16 47 -7 13 -7 19 0 19 5 0 10 -7 10 -15 0
-8 4 -15 10 -15 20 0 -69 193 -124 268 -70 96 -107 142 -115 142 -9 0 9 -74
22 -86 4 -4 7 -17 7 -28 -1 -21 -1 -21 -15 -2 -8 11 -15 30 -15 43 0 27 -26
83 -39 83 -5 0 -2 -27 6 -60 7 -34 11 -65 8 -69 -2 -5 13 -25 36 -46 32 -29
43 -34 55 -24 11 9 14 8 14 -5 0 -9 -5 -15 -12 -13 -7 1 -15 -11 -19 -28 l-7
-30 -1 30 c-1 33 -12 45 -92 99 -56 37 -79 35 -79 -7 0 -16 -3 -18 -12 -9 -32
32 -37 3 -8 -53 31 -60 16 -53 -18 9 -16 30 -32 78 -36 107 -7 52 -7 53 12 36
22 -20 40 -23 20 -3 -23 23 -79 48 -94 42 -22 -8 -29 -6 -26 9 1 7 -12 25 -29
39 -17 14 -27 26 -22 26 5 0 14 -5 21 -12 23 -23 21 -1 -7 53 -28 56 -103 158
-126 171 -12 7 -79 -23 -105 -48 -12 -12 -12 -18 -2 -34 10 -16 9 -18 -3 -14
-12 5 -15 -5 -16 -57 0 -35 -4 -84 -8 -109 -6 -32 -7 -15 -5 55 4 97 3 100
-22 122 -14 12 -43 27 -63 34 -20 6 -56 22 -81 34 -25 13 -72 26 -104 30 l-59
8 7 -29 c4 -16 9 -37 12 -46 3 -10 2 -18 -3 -18 -5 0 -16 23 -26 50 -19 54
-34 63 -42 28z m315 -168 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4
10 6 0 11 -4 11 -10z m80 -187 c0 -4 17 -18 37 -29 l37 -21 -31 1 c-17 0 -29
4 -26 9 2 4 -3 7 -11 7 -9 0 -19 0 -23 1 -5 0 -11 -10 -14 -23 -5 -21 -6 -20
-13 10 -4 17 -12 32 -17 32 -6 0 -7 4 -4 10 3 5 -9 19 -27 30 -38 23 -30 27
11 5 32 -16 43 -11 33 13 -3 10 5 5 21 -10 15 -15 27 -31 27 -35z m497 -65
c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m195 -32 l22 -31 -28 25
c-15 14 -33 34 -39 45 -9 18 -9 19 7 6 9 -8 27 -28 38 -45z m-592 29 c11 -13
10 -14 -4 -9 -9 3 -16 10 -16 15 0 13 6 11 20 -6z m-1880 -114 c0 -5 -7 -11
-15 -15 -15 -5 -20 5 -8 17 9 10 23 9 23 -2z m2504 -7 c3 -8 2 -12 -4 -9 -6 3
-10 10 -10 16 0 14 7 11 14 -7z m-2397 -46 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13
3 -3 4 -12 1 -19z m2049 -6 c3 -9 10 -26 16 -37 8 -16 8 -18 -3 -7 -19 18 -29
15 -29 -10 0 -28 -8 -20 -12 14 -2 15 -7 30 -11 34 -12 13 -8 20 14 21 11 1
22 -6 25 -15z m-19 -114 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m113 -39 c0 -5 -4 -9 -10 -9 -5 0 -10 7 -10 16 0 8 5 12 10 9 6 -3 10 -10 10
-16z m-900 1 c0 -5 -5 -10 -11 -10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4
-10z m-40 -20 c-8 -5 -19 -10 -25 -10 -5 0 -3 5 5 10 8 5 20 10 25 10 6 0 3
-5 -5 -10z m817 -42 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z
m-2180 0 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m1705 -20 c-7
-7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7 -17z m-217 -48 c3 -5 1 -10
-4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m223 -15 c-3 -3 -9
2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m-1668 -38 c0 -5 9 -7 21 -4 18
5 20 2 14 -20 -4 -17 0 -32 12 -47 18 -21 18 -21 -3 -3 -26 22 -34 22 -34 -2
0 -45 -19 -27 -23 21 -2 29 -7 64 -11 78 -7 24 -7 24 8 6 9 -11 16 -24 16 -29z
m1640 24 c0 -12 -20 -25 -27 -18 -7 7 6 27 18 27 5 0 9 -4 9 -9z m40 -33 c0
-6 -7 -5 -15 2 -8 7 -15 17 -15 22 0 6 7 5 15 -2 8 -7 15 -17 15 -22z m255
-16 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9 12 -12z m-280 -31 c-6
-21 -25 -29 -25 -11 0 6 5 10 10 10 6 0 10 8 10 17 0 9 3 14 6 10 3 -3 3 -15
-1 -26z m105 -11 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0
10 -4 10 -10z m-983 -47 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0
-35z m1063 21 c0 -8 -4 -12 -10 -9 -5 3 -10 10 -10 16 0 5 5 9 10 9 6 0 10 -7
10 -16z m-1897 -19 c-7 -21 -13 -19 -13 6 0 11 4 18 10 14 5 -3 7 -12 3 -20z
m1518 -2 c13 3 20 -2 25 -17 3 -11 18 -32 32 -44 22 -20 23 -22 5 -13 -12 6
-24 15 -28 20 -3 5 -21 8 -40 7 -30 -3 -33 -1 -23 11 10 12 7 19 -12 35 -25
19 -25 19 -1 8 12 -7 31 -10 42 -7z m-1484 -25 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z m1783 13 c0 -5 -9 -11 -20 -14 -22 -6 -28 8 -7 16 19
8 27 8 27 -2z m-820 -5 c0 -2 -8 -10 -17 -17 -16 -13 -17 -12 -4 4 13 16 21
21 21 13z m-921 -51 c0 -5 -4 -3 -9 5 -5 8 -9 22 -9 30 0 16 17 -16 18 -35z
m-74 6 c3 -5 1 -12 -5 -16 -5 -3 -10 1 -10 9 0 18 6 21 15 7z m564 -5 c7 -8
14 -31 17 -53 l5 -38 -15 40 c-9 22 -16 42 -16 44 0 2 -7 -2 -15 -9 -16 -14
-18 -10 -9 14 8 20 18 20 33 2z m-4 -166 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11
10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-104 -77 c13 -17 13 -17 -6 -3 -11 8 -22
16 -24 17 -2 2 0 3 6 3 6 0 17 -8 24 -17z m-406 -11 c-3 -3 -11 0 -18 7 -9 10
-8 11 6 5 10 -3 15 -9 12 -12z m570 -112 c3 -5 2 -10 -4 -10 -5 0 -13 5 -16
10 -3 6 -2 10 4 10 5 0 13 -4 16 -10z m-480 -10 c3 -5 1 -10 -4 -10 -6 0 -11
5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m550 -30 c11 18 23 11 18 -10 -3 -11
-1 -20 5 -20 5 0 12 -9 15 -20 3 -11 11 -19 19 -17 7 2 10 2 6 0 -5 -3 -8 -12
-8 -21 0 -11 -8 -5 -22 15 -26 37 -42 41 -57 16 -14 -24 -14 -7 0 19 10 18 8
24 -12 41 l-24 19 27 -16 c17 -10 29 -12 33 -6z m-507 -6 c19 -13 25 -14 39
-2 15 12 15 11 3 -8 -12 -19 -11 -24 3 -39 24 -23 21 -32 -3 -10 -24 21 -25
21 -39 -25 -10 -34 -10 -33 -5 11 5 40 2 50 -17 68 -27 25 -14 28 19 5z
m-1014 -69 c5 -22 4 -26 -4 -15 -5 8 -10 24 -10 34 0 26 6 18 14 -19z m856
-20 c0 -5 -5 -3 -10 5 -5 8 -10 20 -10 25 0 6 5 3 10 -5 5 -8 10 -19 10 -25z
m678 20 c-8 -8 -198 -55 -217 -54 -13 1 -13 2 2 6 9 2 17 8 17 11 0 4 12 8 28
9 15 1 56 8 92 16 74 17 85 19 78 12z m-1133 -64 c-3 -11 -14 -21 -24 -21 -38
0 -56 51 -23 69 24 14 57 -19 47 -48z m-359 -2 c16 -16 22 -28 14 -24 -13 5
-56 55 -47 55 2 0 16 -14 33 -31z"/>
<path d="M4980 11547 c-14 -6 -38 -16 -55 -23 -85 -36 -184 -84 -189 -93 -4
-5 3 -12 14 -16 11 -3 20 -11 20 -16 0 -14 37 -11 120 11 155 40 161 42 155
57 -3 11 -1 13 10 10 8 -4 17 -2 19 2 3 5 -11 11 -32 15 -21 3 -46 12 -57 20
-20 15 -20 15 2 16 23 0 39 15 26 23 -5 3 -19 0 -33 -6z"/>
<path d="M6416 11538 c-3 -13 -5 -32 -5 -43 1 -11 5 -2 10 19 10 42 6 62 -5
24z"/>
<path d="M7035 11550 c5 -8 24 -35 41 -60 18 -25 38 -58 43 -73 6 -15 15 -27
21 -27 17 0 -46 113 -81 145 -17 17 -28 23 -24 15z"/>
<path d="M5010 11520 c0 -5 7 -10 15 -10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8
0 -15 -4 -15 -10z"/>
<path d="M7378 11523 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7299 11477 c19 -20 39 -37 43 -37 10 0 -27 39 -57 60 -11 8 -4 -3
14 -23z"/>
<path d="M7427 11439 c9 -8 44 -14 100 -15 105 -3 84 11 -33 21 -65 6 -77 5
-67 -6z"/>
<path d="M5315 11430 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M4685 11400 c-3 -11 -9 -21 -13 -21 -4 -1 -17 -3 -30 -4 -23 -2 -56
-25 -36 -25 6 0 15 5 22 12 9 9 12 9 12 0 0 -15 14 -15 62 -2 35 10 37 12 26
35 -14 30 -34 32 -43 5z"/>
<path d="M4920 11393 c-14 -3 -47 -10 -74 -17 -48 -12 -48 -13 -19 -19 22 -4
32 -13 37 -32 7 -28 33 -33 69 -13 29 15 51 38 38 38 -17 0 -13 21 7 36 15 12
15 13 -8 12 -14 0 -36 -3 -50 -5z"/>
<path d="M7460 11386 c0 -9 5 -16 10 -16 6 0 10 -4 10 -10 0 -17 114 -178 125
-175 5 1 7 0 3 -2 -13 -7 -9 -30 5 -36 8 -3 40 -8 73 -12 32 -4 82 -13 109
-20 79 -21 115 -25 115 -15 0 6 -7 10 -16 10 -9 0 -46 9 -82 20 -37 10 -87 24
-111 30 -23 6 -41 14 -38 17 7 7 197 -25 219 -38 26 -14 27 -13 21 34 -7 49
-19 68 -39 60 -9 -3 -14 2 -14 16 0 14 -12 26 -42 40 -64 28 -135 51 -166 52
-19 1 -14 4 17 10 24 5 46 10 48 13 7 6 -91 24 -174 31 -62 5 -73 4 -73 -9z"/>
<path d="M7390 11375 c7 -9 32 -30 54 -47 l41 -32 -45 47 c-40 43 -80 68 -50
32z"/>
<path d="M5293 11350 c-13 -10 -23 -23 -23 -29 0 -5 12 1 27 15 31 29 28 40
-4 14z"/>
<path d="M7728 11353 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4748 11343 c-10 -2 -18 -8 -18 -12 0 -4 -19 -13 -42 -20 -39 -12
-99 -48 -106 -63 -2 -5 -10 -8 -18 -8 -8 0 -11 -6 -8 -15 5 -11 2 -13 -12 -8
-11 4 -15 3 -10 -5 7 -12 -84 -112 -102 -112 -6 0 -17 -6 -24 -14 -8 -7 -28
-21 -46 -30 -18 -9 -32 -20 -32 -24 0 -4 -18 -28 -40 -52 -54 -59 -84 -113
-105 -183 -25 -85 -23 -86 85 -68 75 13 94 20 101 36 4 11 18 31 29 45 17 20
19 21 11 4 -19 -39 -43 -109 -56 -164 -7 -30 -13 -46 -14 -35 0 11 3 37 8 58
8 33 7 37 -7 33 -10 -2 -46 -10 -82 -16 -93 -18 -100 -23 -90 -62 13 -60 52
-129 77 -139 24 -9 68 -3 88 11 6 4 19 10 30 13 11 3 45 15 75 26 65 25 70 26
44 6 -18 -14 -17 -14 11 -5 32 11 69 27 97 41 10 5 25 9 33 9 8 0 15 5 15 11
0 6 8 8 18 5 11 -4 27 2 39 13 11 11 23 18 26 15 7 -8 24 50 41 141 8 44 31
127 51 185 20 58 39 113 42 123 3 9 9 17 13 17 4 0 10 10 13 23 2 12 8 30 11
39 11 26 -29 61 -61 53 -19 -4 -32 0 -49 16 -28 26 -31 55 -8 80 9 10 13 23 9
28 -6 11 -9 12 -37 4z m-63 -323 c4 -16 4 -34 0 -40 -9 -15 -86 -50 -96 -44
-13 8 -11 31 4 38 9 5 9 7 0 12 -18 8 45 59 79 63 3 1 9 -12 13 -29z m-204
-118 c-5 -9 -20 -26 -32 -37 -23 -20 -23 -20 -9 0 41 54 59 70 41 37z"/>
<path d="M4618 11333 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7200 11325 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5
0 -10 -7 -10 -15z"/>
<path d="M5311 11307 c-13 -21 -12 -21 5 -5 10 10 16 20 13 22 -3 3 -11 -5
-18 -17z"/>
<path d="M4512 11288 c-23 -18 -42 -36 -42 -40 0 -11 78 44 84 60 8 17 5 16
-42 -20z"/>
<path d="M5215 11271 c-3 -5 -1 -12 5 -16 5 -3 10 1 10 9 0 18 -6 21 -15 7z"/>
<path d="M5107 11140 c-21 -25 -39 -26 -30 -2 3 9 -3 5 -15 -10 -12 -14 -22
-32 -22 -40 0 -11 2 -11 9 1 5 7 17 11 28 7 14 -4 23 2 37 25 21 36 17 47 -7
19z"/>
<path d="M7927 11153 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M7632 11113 c38 -77 88 -187 88 -195 0 -14 57 29 113 84 53 53 57 64
25 71 -13 2 -50 12 -83 20 -78 20 -148 30 -143 20z"/>
<path d="M8358 11100 c-3 -8 -10 -29 -15 -46 l-10 -32 86 -32 c115 -43 327
-149 404 -201 34 -23 90 -66 125 -96 34 -30 62 -52 62 -48 0 13 -115 116 -160
142 -25 15 -47 30 -50 33 -3 4 -21 15 -40 26 -19 10 -40 24 -47 30 -7 7 -47
26 -90 44 -43 18 -82 36 -88 40 -5 4 -37 19 -70 34 -33 14 -54 25 -47 26 7 0
39 -11 72 -25 60 -25 116 -33 105 -15 -3 6 -15 10 -26 10 -11 0 -18 4 -15 9 3
4 -12 17 -34 27 -22 10 -40 22 -40 25 0 12 -59 31 -71 24 -6 -4 -15 -1 -20 6
-7 12 -9 11 -10 -1 0 -8 -4 -4 -9 10 -5 17 -9 20 -12 10z"/>
<path d="M4254 11085 c-11 -8 -29 -15 -40 -15 -12 0 -32 -11 -45 -25 -13 -13
-28 -25 -34 -25 -5 0 -25 -14 -43 -30 -19 -16 -47 -39 -63 -52 -16 -13 -29
-27 -29 -33 0 -5 -17 -21 -37 -35 -20 -14 -64 -51 -96 -82 l-60 -58 67 0 c61
0 66 -1 52 -16 -21 -20 -20 -25 2 -17 15 6 15 5 4 -10 -12 -14 -10 -15 25 -10
21 4 71 14 112 22 l73 16 27 75 c32 92 73 164 118 207 18 18 33 37 33 42 0 5
7 11 15 15 24 9 17 24 -8 19 -14 -3 -31 2 -39 11 -14 13 -18 13 -34 1z"/>
<path d="M8276 11064 c-8 -20 -3 -27 18 -22 12 2 13 6 2 21 -13 16 -14 16 -20
1z"/>
<path d="M8009 11053 c-13 -16 -12 -17 4 -4 16 13 21 21 13 21 -2 0 -10 -8
-17 -17z"/>
<path d="M4972 11018 c-7 -7 -12 -21 -12 -32 0 -17 3 -16 15 8 17 32 15 42 -3
24z"/>
<path d="M7909 10947 c-46 -46 -102 -98 -124 -116 -22 -18 -33 -29 -25 -25 21
11 162 130 179 151 8 10 26 30 40 46 51 55 12 24 -70 -56z"/>
<path d="M8207 10983 c-12 -12 -7 -22 8 -17 8 4 15 1 15 -5 0 -6 7 -11 15 -11
20 0 19 10 -2 26 -21 15 -27 17 -36 7z"/>
<path d="M8286 10952 c-14 -14 3 -25 158 -101 234 -115 378 -227 433 -335 52
-102 14 -260 -85 -362 -57 -58 -146 -125 -220 -164 -94 -50 -85 -29 13 30 267
161 350 356 228 532 -74 109 -183 190 -403 299 l-144 71 -24 -28 -25 -28 24
-10 c149 -61 300 -156 390 -246 112 -111 145 -219 99 -325 -63 -146 -224 -264
-534 -390 -124 -49 -150 -63 -139 -74 11 -9 25 -9 73 5 33 9 63 14 67 10 3 -3
-3 -6 -15 -6 -11 0 -24 -4 -27 -10 -8 -13 16 -13 51 0 15 6 28 9 30 7 2 -2
-30 -17 -71 -32 -41 -16 -75 -33 -75 -37 0 -4 -8 -8 -17 -8 -10 0 -25 -5 -33
-11 -32 -23 85 4 203 46 201 71 405 171 517 252 64 47 148 143 177 201 24 49
28 69 28 142 0 71 -4 93 -25 135 -33 65 -146 179 -239 240 -115 76 -401 212
-415 197z m95 -1047 c-18 -8 -36 -15 -40 -15 -13 1 45 29 59 29 8 0 0 -6 -19
-14z m-94 -41 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m38 -4
c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z m-90 -10 c-3 -5 -11
-10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z"/>
<path d="M8155 10929 c-20 -21 -20 -21 14 -39 21 -11 27 -9 49 14 29 29 29 31
-14 39 -24 5 -36 1 -49 -14z"/>
<path d="M4960 10916 c-12 -33 -13 -66 -1 -66 9 0 23 81 16 89 -3 2 -9 -8 -15
-23z"/>
<path d="M7800 10900 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10
5z"/>
<path d="M5487 10883 c-9 -15 2 -45 16 -40 6 2 13 9 15 17 3 7 0 10 -6 6 -6
-3 -12 2 -14 11 -2 12 -6 14 -11 6z"/>
<path d="M8137 10867 c4 -7 0 -8 -11 -4 -10 4 -15 3 -11 -3 3 -6 -3 -10 -15
-10 -12 0 -65 -35 -118 -78 -54 -42 -116 -91 -139 -107 -25 -17 -41 -36 -38
-43 3 -8 5 -20 5 -28 0 -8 5 -14 10 -14 27 0 350 258 350 280 0 4 -9 10 -20
13 -13 3 -18 1 -13 -6z"/>
<path d="M6582 10840 c-39 -18 -61 -40 -26 -26 12 4 15 2 10 -9 -3 -8 -1 -15
5 -15 6 0 13 9 16 20 3 11 10 20 15 20 6 0 8 -7 4 -15 -3 -8 -2 -15 3 -15 9 0
25 49 19 56 -2 1 -22 -6 -46 -16z"/>
<path d="M7648 10822 c-26 -20 -67 -52 -92 -71 -25 -18 -43 -37 -41 -42 8 -13
35 1 35 18 0 11 7 14 21 10 12 -3 18 -3 15 0 -10 10 33 35 47 27 6 -4 9 -3 4
1 -4 5 12 28 35 52 51 52 40 55 -24 5z"/>
<path d="M7995 10823 c-22 -19 -54 -45 -71 -57 -17 -11 -63 -43 -102 -70 -40
-27 -72 -53 -72 -58 0 -15 222 147 288 210 32 29 -7 8 -43 -25z"/>
<path d="M5545 10840 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M8160 10811 c-87 -74 -207 -167 -273 -211 l-67 -45 6 -85 c4 -47 7
-86 8 -87 1 -1 20 10 43 25 50 32 73 68 66 105 -3 17 -1 27 7 27 7 0 10 7 6
15 -4 11 1 15 19 15 13 0 30 -7 39 -15 8 -8 22 -15 30 -15 9 0 13 -6 10 -14
-3 -9 5 -21 20 -31 29 -20 86 -14 110 10 20 21 29 19 16 -4 -14 -27 -13 -41 4
-41 16 0 24 -57 16 -105 -4 -22 -12 -31 -28 -33 -16 -3 -25 -12 -29 -35 -7
-31 -7 -31 -13 -7 -3 15 -18 30 -38 39 -17 8 -32 20 -32 27 0 6 -7 14 -15 18
-8 3 -15 15 -15 26 0 23 -31 41 -38 22 -5 -17 -19 -15 -42 8 l-21 21 -45 -35
c-25 -19 -50 -36 -56 -38 -7 -3 -14 -52 -19 -122 -8 -117 -15 -184 -26 -240
-4 -23 -2 -28 10 -23 11 4 14 1 11 -7 -11 -28 16 -25 50 5 26 22 41 29 56 24
28 -9 48 -51 32 -67 -7 -7 -12 -20 -12 -30 0 -10 -5 -18 -10 -18 -6 0 -2 -9 8
-20 l19 -20 89 25 c49 14 105 32 124 39 261 103 399 187 484 296 51 65 66 105
66 174 0 133 -126 268 -356 384 -63 32 -84 38 -93 29 -9 -9 -16 -7 -29 8 -38
46 -45 46 -92 6z m92 -203 c-9 -9 -12 -7 -12 12 0 19 3 21 12 12 9 -9 9 -15 0
-24z m103 -153 c0 -28 -29 -25 -33 3 -3 19 0 23 15 20 10 -2 18 -12 18 -23z
m-371 -306 c-33 -13 -48 -11 -35 5 7 8 21 12 33 8 21 -5 21 -6 2 -13z m74 -12
c4 -21 -27 -35 -38 -17 -12 19 0 42 19 38 9 -2 17 -11 19 -21z"/>
<path d="M4930 10814 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M5516 10803 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M6541 10771 c13 -11 28 -17 33 -14 11 7 -22 33 -42 33 -9 0 -6 -7 9
-19z"/>
<path d="M6596 10774 c-4 -9 -4 -19 -1 -22 2 -3 7 3 11 12 4 9 4 19 1 22 -2 3
-7 -3 -11 -12z"/>
<path d="M7630 10724 c-108 -74 -151 -112 -73 -65 69 42 190 131 178 131 -6 0
-53 -30 -105 -66z"/>
<path d="M5486 10753 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M5416 10709 c-11 -11 -17 -21 -14 -24 2 -3 13 4 23 15 24 26 16 33
-9 9z"/>
<path d="M7466 10701 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M4020 10635 c-52 -13 -120 -30 -150 -38 -30 -8 -91 -25 -135 -37 -44
-12 -125 -35 -180 -52 -90 -28 -97 -32 -71 -39 16 -5 52 -6 80 -3 275 31 261
11 -62 -96 -427 -141 -568 -193 -837 -307 -566 -241 -939 -471 -1225 -755 -80
-80 -119 -123 -150 -168 -14 -19 -28 -37 -31 -40 -17 -13 -124 -188 -160 -260
-52 -103 -106 -262 -125 -365 -15 -82 -39 -612 -29 -652 11 -47 7 -3005 -4
-3128 -7 -66 -15 -155 -18 -198 -3 -42 -8 -75 -10 -73 -3 2 -5 210 -5 463 -1
392 -8 501 -18 268 -2 -34 -5 -47 -7 -30 -5 36 -33 116 -45 130 -10 11 -29
-15 -39 -55 -5 -17 -8 -6 -9 35 l-3 60 -8 -65 c-4 -36 -11 -227 -14 -425 -10
-505 4 -661 76 -870 16 -44 94 -215 125 -273 1 -2 10 -5 20 -6 10 -2 20 -9 22
-17 3 -11 1 -11 -8 1 -10 13 -11 12 -6 -3 3 -10 6 -21 6 -23 0 -14 20 -1 25
17 4 11 9 18 12 16 2 -3 -1 -15 -7 -27 -10 -19 -8 -26 21 -56 40 -41 69 -45
69 -10 0 14 5 28 11 31 6 4 8 14 4 23 -5 13 -2 12 15 -3 32 -29 23 -3 -14 36
-58 64 -163 265 -186 357 -6 24 -14 51 -17 60 -4 11 -3 14 4 7 5 -5 15 -30 22
-55 23 -83 119 -264 185 -345 112 -141 241 -249 441 -370 116 -70 517 -275
538 -275 6 0 -3 8 -21 17 -25 12 -30 18 -20 25 9 7 6 8 -9 5 -24 -5 -48 14
-35 28 4 4 -4 5 -16 2 -13 -3 -21 -3 -18 0 6 6 -122 93 -138 93 -5 0 -7 2 -4
5 5 5 159 -69 866 -416 167 -82 331 -162 365 -178 114 -52 321 -148 412 -189
50 -22 134 -61 188 -86 54 -25 100 -46 102 -46 2 0 36 -15 77 -34 153 -70 887
-396 893 -396 2 0 46 -20 97 -44 134 -63 406 -183 688 -304 411 -176 474 -202
477 -198 2 2 -13 11 -34 21 -83 37 -198 98 -210 111 -7 7 -9 15 -5 18 5 3 9
68 11 145 2 123 0 141 -13 141 -21 0 -20 20 1 36 16 11 16 17 6 45 -7 17 -10
36 -7 40 3 5 1 9 -4 9 -5 0 -12 9 -15 19 -3 15 -11 18 -28 14 -16 -3 -20 -2
-11 4 9 7 5 13 -15 23 -59 28 -300 125 -568 229 -154 60 -314 122 -355 139
-41 16 -176 69 -300 117 -124 48 -238 93 -255 100 -16 8 -106 43 -200 80 -93
36 -177 70 -187 75 -9 5 -69 30 -135 56 -132 52 -301 123 -381 161 -30 13 -70
30 -90 38 -21 7 -75 31 -122 53 -134 63 -380 167 -440 186 -30 10 -68 24 -85
31 -26 12 -120 44 -221 75 -17 6 -40 10 -52 10 -22 0 -87 55 -186 158 -28 30
-103 88 -166 130 -63 42 -117 79 -120 82 -3 3 -21 17 -40 30 -19 14 -42 30
-50 37 -8 6 -51 40 -95 74 -139 110 -371 341 -359 360 2 4 0 9 -4 11 -28 11
-153 237 -168 303 -6 29 -6 29 9 10 9 -11 17 -28 17 -37 0 -10 5 -18 11 -18 6
0 8 -8 4 -19 -3 -11 1 -24 12 -32 15 -12 16 -12 10 4 -4 11 -3 16 3 12 6 -3 7
-18 4 -33 -4 -15 -3 -24 1 -20 7 7 45 -32 45 -47 0 -3 6 -12 12 -19 7 -7 27
-31 43 -52 51 -66 187 -204 260 -263 63 -52 302 -217 412 -285 24 -14 51 -26
61 -26 11 0 57 -18 103 -39 51 -24 107 -42 144 -46 64 -8 103 -28 203 -104 31
-24 92 -63 135 -88 42 -25 75 -49 72 -53 -6 -10 113 -69 390 -192 225 -100
333 -146 525 -225 47 -19 101 -41 120 -50 19 -8 71 -28 115 -45 44 -16 141
-53 215 -83 389 -154 484 -191 580 -226 58 -21 141 -52 185 -69 102 -39 142
-54 350 -129 190 -69 248 -90 415 -154 234 -89 474 -174 554 -196 43 -11 63
-8 24 4 -44 14 -588 238 -705 291 -28 13 -54 24 -57 24 -3 0 -33 13 -68 29
-86 39 -132 59 -281 122 -70 30 -123 55 -118 57 6 2 126 -34 268 -81 142 -46
308 -98 368 -116 61 -18 129 -39 152 -47 32 -10 54 -11 90 -4 26 6 63 13 81
16 17 4 32 11 32 15 0 5 9 9 19 9 11 0 32 5 48 12 45 18 54 20 143 29 144 16
341 10 385 -11 11 -5 34 -11 50 -13 83 -10 155 -32 155 -47 0 -21 150 -19 211
4 24 9 96 31 159 50 63 18 214 65 335 105 121 39 224 71 230 71 14 0 -97 -58
-175 -91 -36 -15 -103 -44 -150 -64 -284 -123 -506 -214 -660 -271 -191 -71
-225 -84 -240 -95 -55 -39 245 58 655 210 72 27 218 81 325 121 593 219 1465
571 1910 770 63 28 137 60 164 71 86 35 202 98 226 124 13 14 29 25 37 25 7 0
13 4 13 9 0 5 12 14 28 20 15 6 42 25 60 42 19 18 54 36 87 44 30 8 72 25 92
38 21 13 67 36 103 51 36 16 79 34 95 42 17 7 50 18 75 24 89 23 340 177 570
351 114 86 283 244 350 328 19 24 40 48 45 55 26 28 80 116 119 195 49 96 82
198 101 311 12 71 13 72 14 27 1 -65 -34 -233 -66 -315 -29 -75 -124 -246
-156 -284 -12 -14 -32 -38 -44 -54 -39 -51 -196 -209 -205 -206 -4 1 -8 -4 -8
-11 0 -8 -19 -28 -42 -45 -24 -17 -56 -44 -73 -59 -16 -16 -50 -44 -75 -63
-25 -19 -47 -37 -50 -41 -7 -8 -180 -131 -281 -199 -45 -30 -100 -69 -123 -86
-175 -129 -398 -253 -556 -308 -41 -15 -84 -30 -95 -35 -165 -71 -237 -103
-330 -146 -75 -35 -280 -126 -410 -182 -201 -87 -628 -262 -815 -334 -85 -33
-164 -64 -175 -69 -21 -9 -123 -50 -235 -93 -36 -14 -164 -65 -285 -112 -121
-48 -231 -91 -245 -96 -14 -4 -79 -28 -145 -54 -66 -25 -172 -65 -235 -89
-127 -47 -205 -85 -177 -86 15 0 15 -2 -3 -20 -11 -11 -22 -31 -26 -45 -3 -14
-10 -25 -16 -25 -5 0 -6 -5 -2 -12 4 -7 9 -60 12 -118 5 -143 4 -162 -8 -174
-15 -15 -12 -34 10 -56 23 -23 29 -17 -100 -82 -192 -96 -51 -44 325 119 127
55 286 124 355 153 69 29 130 55 135 58 10 6 132 57 315 132 52 21 131 55 175
74 44 20 91 35 105 35 15 0 19 -3 10 -6 -8 -3 -42 -18 -75 -33 -33 -16 -87
-40 -120 -55 -440 -199 -787 -364 -769 -365 12 0 118 43 209 85 57 26 126 55
131 55 14 0 -1 -19 -23 -30 -17 -7 -23 -14 -15 -17 7 -3 24 2 37 11 14 9 25
12 25 7 0 -5 -9 -13 -20 -16 -29 -9 -25 -18 27 -59 33 -26 55 -36 73 -33 14 2
19 2 13 0 -7 -3 -13 -9 -13 -14 0 -11 -27 -12 -32 0 -1 4 -13 12 -25 15 -19 6
-23 3 -23 -12 0 -16 5 -19 22 -14 13 3 19 1 15 -5 -4 -6 -22 -14 -41 -17 -19
-4 -36 -10 -38 -15 -3 -7 -158 -79 -183 -84 -5 -1 -18 -10 -29 -20 -11 -9 -23
-17 -27 -17 -4 0 -52 -21 -106 -46 -245 -116 -259 -122 -528 -231 -66 -26
-122 -53 -123 -58 -2 -6 -8 -15 -13 -21 -5 -6 -14 -56 -20 -111 -6 -56 -15
-107 -19 -113 -11 -18 -30 -3 -30 25 0 13 -5 25 -11 27 -7 2 -17 47 -23 103
-6 55 -16 107 -21 116 -6 9 -50 34 -100 57 -49 22 -138 63 -197 91 -59 28
-110 51 -112 51 -4 0 -34 14 -310 144 -65 31 -120 56 -123 56 -2 0 -43 19 -91
41 -185 88 -467 216 -697 316 -224 98 -416 185 -910 413 -110 51 -234 107
-275 125 -41 18 -140 64 -220 103 -80 38 -192 92 -250 120 -58 27 -168 80
-245 117 -142 68 -214 102 -410 195 -183 87 -455 224 -540 272 -44 25 -107 60
-140 78 -253 138 -491 344 -623 538 -56 83 -132 254 -161 363 -42 159 -43 190
-38 2057 2 983 1 1882 -3 1997 -4 135 -7 176 -9 115 -5 -189 -18 -207 -21 -30
l-3 165 -8 -155 c-3 -85 -7 -961 -8 -1946 -1 -1739 -1 -1794 19 -1940 37 -274
118 -508 246 -707 24 -37 44 -70 44 -73 0 -3 12 -21 26 -40 15 -19 24 -34 21
-34 -10 0 -127 161 -155 213 -53 98 -49 95 -60 51 -5 -21 -10 -68 -11 -104 -1
-36 -7 -66 -12 -68 -5 -2 -6 -22 -3 -45 4 -30 3 -38 -5 -27 -20 29 -19 2 3
-85 46 -182 118 -336 226 -481 39 -52 67 -94 62 -94 -7 1 -42 47 -142 190 -26
36 -61 95 -80 132 -18 38 -35 66 -37 64 -6 -5 44 -102 101 -199 25 -43 46 -81
46 -85 0 -3 -25 29 -55 72 -30 43 -57 82 -61 85 -8 8 35 -78 47 -93 5 -6 32
-42 61 -81 79 -106 84 -112 213 -240 126 -126 135 -135 254 -229 81 -65 268
-187 346 -226 27 -14 56 -31 63 -38 7 -6 19 -12 25 -12 7 -1 2 -9 -11 -20 -22
-18 -22 -19 -2 -25 25 -8 26 -21 0 -37 -13 -9 -20 -24 -20 -45 0 -21 -7 -37
-22 -47 -15 -11 -23 -30 -28 -66 -4 -27 -3 -50 2 -50 4 0 8 -16 8 -35 0 -29 9
-44 55 -90 31 -30 61 -55 67 -55 6 0 33 -20 59 -45 27 -25 60 -50 74 -57 14
-6 25 -17 25 -25 0 -9 13 -13 40 -13 38 0 86 -24 125 -64 9 -9 28 -16 41 -16
14 0 32 -7 40 -15 9 -8 26 -15 40 -15 14 0 27 -7 30 -15 4 -8 14 -15 23 -15 9
0 61 -23 115 -50 55 -28 104 -50 110 -50 6 0 38 -14 70 -30 32 -17 65 -30 72
-30 8 0 14 -4 14 -10 0 -5 13 -10 29 -10 17 0 33 -5 36 -10 12 -19 110 -63
150 -67 41 -5 176 -51 186 -65 3 -4 27 -12 55 -18 95 -20 104 -22 104 -31 0
-5 9 -9 20 -9 10 0 45 -10 77 -21 31 -12 64 -23 72 -23 32 -3 137 -41 163 -58
14 -10 33 -18 42 -18 8 0 38 -9 66 -20 28 -11 66 -20 85 -20 19 0 35 -4 35
-10 0 -5 8 -10 18 -10 10 0 22 -3 25 -7 4 -3 19 -8 34 -9 15 -2 37 -7 48 -13
11 -5 40 -15 65 -21 25 -6 64 -16 88 -22 23 -6 42 -15 42 -20 0 -4 16 -8 36
-8 19 0 41 -6 49 -13 7 -8 42 -19 77 -26 35 -7 75 -19 90 -27 14 -8 41 -14 60
-14 18 0 53 -9 77 -20 24 -11 51 -20 60 -20 10 0 21 -3 25 -7 6 -7 235 -70
291 -80 17 -3 33 -10 36 -15 4 -6 35 -16 70 -23 131 -26 251 -55 294 -70 25
-8 57 -15 71 -15 14 0 53 -6 87 -14 83 -19 255 -48 342 -56 39 -4 131 -15 205
-25 143 -18 391 -16 530 6 36 5 99 14 140 19 140 17 365 50 405 59 22 5 56 12
75 16 19 3 112 24 205 45 94 21 233 53 310 70 77 18 142 36 143 41 2 5 21 9
43 9 21 0 39 5 39 10 0 6 7 10 15 10 8 0 41 8 72 19 32 10 92 24 133 31 41 7
89 18 105 25 17 7 58 21 93 31 34 9 62 21 62 25 0 4 19 9 43 12 35 3 139 36
282 88 17 6 57 18 89 26 33 8 69 21 80 29 11 8 37 14 56 14 20 0 88 18 151 40
63 22 124 40 136 40 12 0 28 6 35 13 7 7 39 20 70 30 32 10 60 22 63 27 4 6
21 10 40 10 18 0 46 6 62 14 15 8 69 26 118 41 50 15 106 35 125 45 19 10 47
20 63 24 15 3 27 12 27 19 0 7 14 14 32 15 17 2 36 6 42 11 6 5 28 11 49 15
20 4 37 11 37 16 0 6 18 10 39 10 22 0 43 5 46 10 4 6 10 8 14 6 4 -3 75 28
157 69 82 41 154 75 160 75 6 0 17 7 24 15 7 8 20 15 29 15 22 0 181 77 181
88 0 5 16 16 35 25 19 9 35 23 35 32 0 9 9 15 25 15 14 0 39 12 54 27 43 41
59 53 71 53 5 0 10 5 10 11 0 13 58 69 71 69 5 0 9 7 9 15 0 8 11 25 25 39 18
19 25 36 25 66 0 29 4 40 15 40 12 0 15 14 15 64 0 36 -4 68 -10 71 -5 3 -10
27 -10 52 0 36 -4 46 -20 50 -11 3 -20 8 -20 12 0 3 -11 19 -25 35 -17 20 -22
32 -14 37 8 5 7 8 -2 12 -11 4 -10 9 6 22 18 15 18 15 -15 9 l-35 -6 35 34
c19 19 48 43 65 54 34 21 40 26 145 115 217 182 432 456 513 652 24 57 11 44
-23 -24 -36 -70 -107 -181 -144 -224 -15 -16 2 17 37 75 34 58 71 125 81 150
10 25 23 51 28 58 6 7 9 15 6 17 -3 3 -21 -27 -42 -66 -59 -116 -194 -297
-301 -405 -90 -90 -97 -93 -20 -9 171 187 284 361 350 540 20 54 22 80 24 274
1 118 6 220 11 226 6 7 7 14 5 17 -3 3 8 45 24 94 42 128 48 190 8 73 -45
-129 -91 -228 -151 -324 -67 -110 -96 -146 -195 -245 -47 -47 -74 -72 -60 -55
13 16 32 37 41 46 10 9 50 56 89 105 161 201 251 407 312 711 20 103 21 140
24 789 3 604 2 682 -12 688 -13 5 -15 -66 -15 -647 0 -516 -3 -673 -15 -754
-31 -222 -91 -389 -200 -563 -30 -48 -138 -180 -165 -203 -39 -33 -31 -11 14
39 44 49 54 74 16 39 -18 -17 -20 -17 -14 -2 3 9 10 17 15 17 5 0 9 5 9 11 0
6 -6 9 -13 6 -8 -3 -14 1 -14 9 0 14 11 10 39 -13 11 -10 18 -11 23 -4 3 6 3
11 -2 11 -4 0 -3 4 2 8 6 4 22 23 35 42 23 34 23 34 1 16 -15 -14 -20 -15 -16
-5 6 17 -31 24 -40 8 -4 -5 -11 -7 -16 -4 -5 4 -9 -1 -9 -9 0 -9 -6 -16 -14
-16 -9 0 -12 7 -9 20 8 31 -9 24 -50 -19 -25 -27 -35 -45 -31 -58 5 -14 4 -15
-4 -4 -8 12 -14 10 -34 -10 -49 -51 -176 -159 -187 -159 -6 0 -11 -3 -11 -7 0
-5 -25 -26 -55 -48 -57 -41 -70 -53 -36 -35 28 15 35 12 20 -6 -7 -9 -12 -30
-10 -47 3 -28 1 -29 -26 -22 -15 3 -25 3 -21 -1 4 -3 3 -15 -3 -26 -9 -17 -7
-18 18 -12 l28 7 -20 -22 -20 -23 27 13 c15 6 25 16 22 20 -3 5 2 6 10 3 20
-8 12 -20 -26 -40 -17 -9 -40 -25 -51 -35 -12 -10 -26 -19 -33 -19 -7 0 -14
-4 -16 -8 -4 -11 -267 -162 -478 -274 -104 -56 -290 -170 -290 -179 0 -4 -9
-11 -20 -14 -11 -3 -20 -15 -20 -25 0 -10 -5 -22 -10 -25 -6 -4 -8 -10 -5 -15
3 -4 -4 -6 -15 -3 -11 3 -23 9 -26 14 -9 16 -54 9 -107 -15 -29 -14 -77 -34
-107 -46 -30 -12 -78 -32 -108 -46 -29 -13 -54 -24 -56 -24 -2 0 -75 -34 -162
-76 -178 -85 -170 -81 -469 -219 -102 -47 -231 -107 -290 -135 -110 -53 -448
-200 -472 -206 -13 -4 -26 -10 -29 -15 -10 -17 -25 -9 -19 11 3 11 3 20 -1 20
-8 0 -50 -44 -55 -58 -2 -5 -15 -12 -29 -16 -18 -5 -21 -4 -11 2 20 14 24 63
5 55 -17 -6 -46 15 -38 28 3 5 14 9 25 9 10 0 19 5 19 10 0 6 11 15 24 21 16
8 22 17 19 30 -4 13 0 19 11 19 10 0 15 4 12 9 -3 5 8 14 24 20 17 5 30 12 30
15 0 5 -93 -28 -112 -40 -4 -3 -8 -1 -8 4 0 5 24 19 53 31 28 13 59 27 67 32
8 5 31 16 50 25 19 9 80 37 135 64 55 26 132 62 170 80 101 47 197 92 297 139
48 22 92 41 98 41 5 0 10 5 10 10 0 6 4 10 9 10 5 0 20 4 33 9 13 5 25 8 28 7
3 0 18 7 34 17 15 10 35 16 44 12 9 -3 13 -3 10 1 -8 7 119 74 140 74 6 0 12
5 12 10 0 6 6 10 13 10 6 0 37 13 67 30 30 16 63 29 73 30 10 0 15 5 12 10 -3
5 1 10 10 10 17 0 101 46 123 67 17 16 36 17 26 1 -4 -7 -3 -8 4 -4 6 4 9 13
5 21 -3 8 1 15 8 15 7 0 10 2 7 5 -3 3 -36 -10 -74 -29 -116 -57 -345 -158
-350 -153 -3 3 112 64 256 136 144 72 284 146 313 164 29 18 64 38 79 46 15 8
26 18 25 24 -1 5 13 16 31 24 19 7 31 9 27 3 -7 -12 8 -6 77 27 26 13 50 23
53 23 3 0 108 51 233 112 255 127 252 126 232 105 -8 -9 -67 -44 -130 -79 -63
-35 -114 -67 -113 -73 1 -5 -3 -16 -9 -22 -6 -7 -8 -13 -5 -13 10 0 190 92
331 169 573 314 840 600 932 998 21 92 26 142 31 341 4 159 3 232 -4 232 -15
0 -24 174 -32 587 l-6 338 -27 3 c-59 7 -94 -44 -108 -157 -7 -49 -14 -70 -30
-83 -24 -19 -65 -24 -74 -9 -7 11 -66 -16 -66 -30 0 -6 -7 -6 -19 1 -15 8 -23
5 -39 -13 -242 -276 -374 -383 -712 -582 -147 -87 -195 -120 -160 -110 14 4
44 17 68 28 23 11 45 17 48 15 5 -5 -59 -50 -112 -79 -32 -18 -102 -63 -119
-77 -15 -12 -139 -52 -144 -46 -2 2 6 15 19 29 25 26 22 32 -8 15 -21 -12
-330 -146 -427 -185 -38 -16 -74 -32 -79 -37 -14 -11 -36 -10 -36 2 0 6 8 13
18 16 42 14 62 28 50 35 -7 5 21 23 73 49 46 22 89 47 95 55 6 8 29 22 50 31
21 9 34 19 28 21 -14 5 -46 -7 -269 -99 -183 -76 -336 -132 -390 -142 -16 -3
-24 -3 -17 0 6 3 12 11 12 17 0 14 54 49 167 107 45 23 81 46 80 51 -1 4 25
22 58 38 76 39 57 40 -37 2 -73 -28 -138 -47 -138 -38 0 2 19 17 43 33 23 15
62 49 87 74 25 26 68 57 95 69 28 13 73 34 101 47 28 13 55 24 60 24 14 0 96
43 118 63 11 9 30 17 43 17 13 0 23 4 23 10 0 5 16 16 35 25 19 9 39 23 46 31
6 8 15 14 20 14 5 0 32 16 60 37 49 35 54 36 150 40 107 4 158 22 279 101 152
98 199 129 239 162 67 53 179 168 186 190 4 11 14 20 23 20 14 0 14 2 3 9 -10
6 -11 14 -3 26 5 10 7 36 4 58 -3 24 -1 42 7 46 6 4 14 20 17 34 4 24 -1 29
-36 44 -47 21 -51 33 -12 34 25 0 24 2 -13 16 -22 9 -62 19 -90 22 l-50 6 -28
105 c-15 58 -30 120 -34 138 l-6 32 -189 -2 -190 -3 -39 -129 c-21 -71 -40
-130 -42 -132 -1 -2 -54 -4 -117 -4 -93 -2 -115 1 -114 12 1 8 64 207 141 443
180 550 196 603 195 643 l-1 32 167 -2 167 -2 -150 -3 c-201 -5 -217 -23 -19
-23 l149 0 21 -62 c12 -35 68 -205 123 -378 170 -525 197 -600 187 -510 -3 25
-3 39 0 33 3 -7 12 -13 19 -13 16 0 95 76 95 91 0 14 17 11 23 -5 9 -23 67
-26 80 -4 7 10 17 18 22 18 6 0 17 27 24 60 15 67 9 162 -15 249 -18 63 -12
79 10 26 30 -71 49 -204 42 -293 -5 -58 -4 -82 3 -77 6 3 11 13 11 21 0 8 4
14 9 14 5 0 12 18 16 40 7 43 24 53 32 20 6 -24 21 -26 30 -4 3 8 12 13 20 9
25 -9 12 250 -17 340 -45 142 -132 286 -240 399 -79 83 -189 169 -207 161 -8
-2 -12 -1 -8 4 3 5 -12 20 -32 32 -21 13 -40 26 -43 31 -3 4 -15 9 -25 11 -11
2 -47 16 -80 31 -67 30 -164 61 -293 93 -13 3 -52 34 -85 68 -34 34 -82 73
-107 86 -25 13 -46 27 -48 32 -2 4 -10 7 -18 7 -14 0 -54 19 -64 31 -3 3 -21
11 -40 19 -19 8 -37 16 -40 20 -6 6 -91 37 -320 116 -319 110 -819 241 -1145
300 -534 97 -860 137 -1420 175 -267 19 -409 22 -855 23 -520 0 -591 -3 -1035
-39 -182 -15 -554 -56 -680 -75 -214 -32 -299 -45 -450 -71 -609 -106 -1321
-300 -1690 -459 -160 -69 -197 -91 -257 -153 -35 -35 -74 -78 -87 -95 -20 -27
-30 -32 -67 -32 -28 0 -44 -4 -44 -12 0 -9 -3 -9 -12 0 -27 27 -115 9 -221
-45 -50 -25 -201 -121 -241 -153 -186 -147 -307 -293 -374 -450 -56 -132 -66
-181 -66 -345 -1 -141 1 -156 31 -255 61 -198 143 -334 298 -495 81 -83 92
-87 18 -5 -18 19 -31 41 -28 48 5 14 -25 82 -36 82 -4 0 -5 9 -2 20 3 11 10
20 15 20 5 0 7 -8 4 -17 -3 -10 4 -29 15 -43 13 -16 19 -19 15 -7 -17 49 -17
51 0 29 18 -24 172 -176 234 -231 51 -46 289 -205 296 -198 3 3 -3 10 -14 16
-11 6 -26 17 -34 23 -7 7 -31 25 -53 39 -70 47 -215 175 -293 259 -141 154
-249 333 -289 480 -24 88 -24 297 0 355 l16 40 -7 -45 c-13 -80 -8 -272 8
-322 16 -53 30 -62 30 -20 1 23 2 25 11 9 6 -9 7 -26 4 -37 -5 -17 -2 -20 28
-20 48 0 66 -34 47 -90 -10 -31 -10 -45 -2 -62 12 -22 12 -22 7 -1 -7 26 4 73
16 73 5 0 9 -15 9 -34 0 -34 34 -106 50 -106 4 0 8 -19 8 -42 1 -67 4 -77 20
-70 11 4 14 1 9 -11 -4 -11 -2 -14 9 -10 10 4 12 0 7 -13 -5 -13 -3 -16 10
-11 11 4 14 2 11 -7 -3 -8 0 -17 7 -22 7 -4 10 -3 6 3 -4 6 3 8 18 5 14 -2 25
-8 25 -12 0 -5 -9 -6 -20 -3 -29 8 -25 0 21 -46 26 -26 46 -38 57 -34 11 5 14
2 9 -10 -4 -11 -2 -14 9 -10 10 4 12 0 7 -13 -5 -13 -3 -16 10 -11 9 3 17 2
17 -3 0 -16 65 -70 78 -65 7 3 10 0 7 -5 -3 -6 0 -10 7 -10 7 0 21 -11 33 -26
11 -14 27 -26 35 -28 26 -5 68 -24 110 -51 22 -14 45 -23 51 -20 5 4 8 1 7 -5
-2 -6 15 -19 37 -27 22 -9 59 -29 82 -45 23 -15 48 -28 55 -28 7 0 22 -7 32
-15 11 -8 28 -15 38 -15 10 0 18 -4 18 -9 0 -5 13 -12 30 -16 16 -4 30 -11 30
-16 0 -5 7 -9 15 -9 9 0 18 -6 21 -14 4 -12 46 -31 50 -23 1 1 11 -6 22 -16
11 -10 33 -22 48 -26 16 -5 28 -13 27 -20 -2 -6 4 -11 12 -11 8 0 26 -9 39
-21 13 -11 45 -31 70 -43 26 -12 43 -25 39 -29 -3 -4 3 -7 15 -7 11 0 24 -4
27 -10 3 -5 14 -10 23 -10 9 0 44 -13 78 -29 34 -16 80 -32 102 -36 23 -4 44
-11 47 -15 8 -13 66 -40 87 -40 10 0 18 -4 18 -9 0 -5 9 -13 20 -16 11 -3 26
-13 35 -21 8 -8 38 -30 67 -49 69 -46 40 -46 -84 -1 -84 30 -126 48 -321 132
-32 14 -63 24 -69 22 -6 -2 26 -19 70 -38 44 -19 78 -39 75 -44 -4 -5 -1 -6 5
-2 13 8 206 -67 196 -76 -3 -4 -13 -5 -22 -2 -10 2 49 -28 130 -68 135 -67
173 -96 153 -116 -10 -11 -337 109 -604 222 -47 20 -86 34 -88 33 -2 -2 22
-16 52 -32 58 -29 67 -36 35 -28 -11 3 -20 3 -20 1 0 -10 102 -68 111 -62 5 3
9 1 9 -4 0 -5 48 -33 108 -62 59 -29 102 -55 95 -57 -21 -7 -273 98 -528 221
-88 42 -120 50 -80 19 20 -16 20 -16 0 -8 -11 4 -42 12 -70 17 -27 5 -59 13
-70 17 -64 28 -90 42 -185 102 -58 36 -139 86 -180 110 -41 24 -79 47 -85 52
-5 4 -43 30 -82 56 -74 50 -143 105 -217 175 l-41 38 45 -32 c25 -18 70 -48
100 -68 30 -21 57 -39 60 -42 9 -10 182 -115 253 -154 71 -39 93 -43 30 -5
-469 277 -745 553 -888 886 -58 136 -79 249 -79 433 0 165 9 215 61 354 89
238 283 455 585 657 49 33 99 69 111 80 l22 21 -22 -11 c-50 -26 -41 -8 18 36
35 25 66 49 69 52 14 16 71 51 84 51 8 0 18 5 21 10 3 6 16 10 29 10 12 0 26
4 32 9 14 13 166 62 173 56 5 -6 -12 -20 -34 -28 -5 -3 -7 -7 -4 -11 4 -4 22
0 40 8 72 31 481 176 634 224 424 133 866 235 1435 331 1167 198 2366 222
3555 71 278 -35 370 -49 630 -96 397 -73 854 -182 1125 -269 63 -20 135 -43
160 -50 57 -17 343 -115 434 -149 38 -14 74 -26 80 -25 13 0 -124 68 -140 69
-13 0 -41 30 -29 30 4 0 21 -6 38 -14 27 -11 141 -52 312 -113 59 -21 140 -58
143 -65 2 -5 10 -8 18 -8 8 0 14 -4 14 -9 0 -5 50 -42 110 -82 61 -41 106 -75
101 -77 -6 -2 -30 8 -54 22 -98 58 -63 17 54 -61 323 -219 505 -448 587 -741
25 -89 27 -111 26 -267 -1 -114 -6 -195 -17 -245 -16 -75 -14 -97 4 -70 8 11
9 8 4 -13 -5 -26 -4 -27 15 -17 23 12 24 8 11 -37 -11 -39 1 -53 49 -53 l37 0
9 358 c5 196 8 492 7 657 0 165 -1 563 -2 885 -1 322 -6 644 -12 716 -24 312
-146 589 -374 851 -190 218 -357 362 -622 536 -246 162 -532 307 -943 479 -52
22 -114 49 -137 59 -23 10 -48 19 -55 19 -8 0 -18 4 -23 8 -6 5 -50 24 -100
42 -49 18 -95 37 -101 42 -14 10 -24 -12 -24 -55 -1 -44 -38 -130 -87 -203
-139 -204 -465 -383 -971 -535 -125 -37 -142 -44 -136 -61 3 -11 0 -20 -10
-24 -9 -3 -16 -10 -16 -16 0 -11 -51 -81 -62 -86 -16 -7 -7 -22 14 -22 27 0
16 -11 -25 -25 -18 -5 -32 -15 -32 -21 0 -14 -38 -88 -47 -92 -5 -2 -8 -14 -8
-27 0 -25 -7 -23 170 -49 492 -72 1066 -197 1525 -332 132 -39 160 -48 385
-127 85 -31 171 -60 190 -67 19 -6 44 -16 55 -21 11 -4 56 -20 99 -35 44 -14
102 -35 130 -46 28 -11 74 -26 101 -33 72 -19 158 -74 245 -157 41 -39 120
-106 175 -147 122 -92 292 -259 367 -361 99 -132 171 -300 202 -469 17 -89 20
-156 4 -81 -42 200 -81 308 -150 415 -37 58 -176 212 -244 271 -116 100 -277
214 -300 214 -6 0 -15 5 -22 12 -6 6 -20 13 -29 14 -24 4 -63 26 -58 33 2 4
-8 6 -22 5 -14 0 -49 9 -77 21 -48 20 -266 130 -331 167 -16 9 -39 21 -51 27
-12 5 -30 21 -41 36 -44 62 -576 252 -1003 360 -268 67 -667 148 -705 143 -11
-2 30 -14 90 -26 202 -43 205 -57 5 -22 -234 41 -816 112 -1110 136 -965 78
-1762 69 -2505 -31 -55 -7 -170 -22 -255 -34 -310 -42 -361 -47 -366 -40 -2 4
3 15 12 23 8 9 14 16 11 16 -25 0 -250 -38 -387 -66 -200 -40 -569 -132 -680
-169 l-75 -26 60 6 c33 3 76 8 95 11 67 10 6 -13 -305 -116 -170 -56 -326
-108 -345 -115 -19 -8 -78 -30 -130 -49 -52 -19 -129 -49 -170 -66 -41 -17
-82 -33 -90 -34 -8 -2 -9 -1 -2 1 6 3 12 8 12 13 0 4 11 11 25 14 14 4 24 10
21 14 -2 4 10 14 27 21 59 24 186 86 182 89 -10 10 -260 -98 -475 -204 -412
-205 -690 -416 -831 -632 -21 -31 -42 -61 -46 -67 -19 -22 -64 -119 -89 -187
-31 -89 -25 -29 8 72 80 248 286 487 600 693 206 135 387 229 678 352 36 15
74 31 85 36 11 4 58 22 105 40 47 17 103 39 125 49 22 9 72 27 110 40 39 12
102 33 140 46 39 13 122 37 185 53 63 17 131 35 150 40 202 61 894 208 1155
245 835 119 1608 155 2617 121 104 -3 120 -2 140 15 25 21 18 26 -13 10 -30
-17 -22 3 9 21 20 11 28 24 30 48 2 29 0 33 -18 28 -23 -6 -28 8 -5 17 8 3 15
12 15 21 0 19 -47 20 -118 3 -49 -11 -75 -37 -77 -77 0 -8 -5 -16 -12 -18 -9
-3 -10 4 -3 26 5 17 12 36 16 42 5 9 2 10 -12 5 -16 -6 -16 -4 4 17 12 13 22
29 22 35 0 7 5 12 10 12 6 0 10 -9 10 -21 0 -23 1 -23 95 3 37 10 38 12 15 18
-24 6 -24 7 12 20 32 12 34 15 21 28 -13 14 -25 13 -106 -3 -51 -9 -123 -26
-160 -36 -38 -10 -79 -21 -90 -24 -18 -5 -17 -3 4 9 28 16 120 48 260 90 78
23 99 37 99 65 0 18 -48 29 -91 21 -55 -10 -63 -5 -14 9 20 5 47 21 60 35 23
25 23 26 4 26 -12 0 -23 -8 -26 -20 -6 -24 -23 -27 -23 -4 0 10 -5 14 -15 10
-42 -16 -127 -37 -131 -33 -3 3 28 18 70 33 l75 28 26 69 c36 99 33 112 -24
101 -25 -5 -30 -10 -26 -25 5 -14 0 -22 -19 -29 -15 -5 -26 -13 -25 -17 5 -28
-2 -36 -15 -18 -13 18 -15 17 -44 -13 -34 -35 -56 -45 -27 -12 14 16 16 23 7
32 -15 15 -16 38 -2 38 6 0 10 -7 10 -15 0 -8 5 -15 10 -15 6 0 10 7 10 15 0
8 -4 15 -8 15 -5 0 -15 11 -22 25 -17 31 -30 32 -31 3 0 -13 -3 -17 -6 -10 -7
17 -72 15 -107 -3 -15 -8 -33 -15 -38 -15 -6 0 -38 -13 -72 -29 -33 -15 -99
-43 -146 -61 -47 -18 -92 -39 -101 -47 -9 -7 -18 -10 -21 -7 -4 3 -44 -7 -90
-21 -45 -15 -92 -28 -103 -30 -36 -5 -120 -40 -135 -56 -14 -14 -17 -13 -32 3
-20 20 -15 25 33 33 31 5 86 24 229 77 30 12 69 27 85 34 17 7 71 29 120 49
50 21 110 47 135 60 25 13 70 33 100 45 30 12 65 29 78 38 22 14 22 16 5 34
-17 19 -17 19 -35 -4 l-18 -23 0 22 c0 18 -27 45 -56 57 -1 1 -5 12 -9 25 -6
20 -4 23 9 18 21 -8 46 2 46 19 0 17 -4 17 -43 0 -67 -28 -88 -36 -100 -36 -7
1 5 10 25 21 35 18 37 21 25 42 -6 12 -13 24 -14 25 -1 2 -71 -23 -155 -56
-179 -70 -419 -152 -638 -217 -85 -25 -176 -53 -202 -61 -128 -39 -490 -121
-598 -136 -23 -3 -21 -6 23 -32 41 -24 54 -27 95 -21 54 7 304 69 343 83 14 6
75 22 135 36 122 30 320 91 559 174 193 66 197 67 163 47 -30 -17 -624 -215
-646 -215 -7 0 -29 -7 -49 -15 -34 -14 -35 -16 -19 -33 32 -36 13 -80 -41 -96
-17 -6 -29 -1 -48 21 -14 15 -23 36 -21 46 2 9 0 17 -5 17 -13 0 -373 -92
-378 -96 -7 -6 29 -31 78 -54 24 -12 41 -23 39 -25 -6 -6 -109 37 -143 59 -27
18 -30 17 -129 -3 -301 -63 -684 -96 -1021 -88 -329 8 -488 36 -652 117 -66
33 -89 50 -115 87 -42 63 -48 126 -18 207 43 114 253 299 480 424 78 42 368
187 413 205 20 9 37 18 37 20 0 2 -13 33 -29 69 -16 35 -32 81 -36 101 -8 43
-5 43 -135 12z m-487 -162 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13
-5z m-488 -356 c-27 -13 -66 -29 -85 -37 -186 -71 -565 -253 -711 -341 -186
-112 -257 -162 -252 -178 3 -11 2 -12 -4 -3 -7 9 -32 -5 -99 -54 -49 -36 -98
-74 -109 -84 -11 -11 -51 -46 -90 -78 -67 -57 -223 -215 -293 -298 l-33 -39
28 45 c36 59 33 54 101 135 204 242 521 476 928 683 92 47 142 70 329 150 183
78 424 160 290 99z m3595 -171 c0 -2 -13 -9 -30 -15 -35 -12 -41 -5 -7 9 25
10 37 12 37 6z m-70 -25 c0 -9 -54 -32 -74 -30 -8 0 51 32 72 38 1 1 2 -3 2
-8z m73 -36 c4 -8 2 -17 -3 -20 -6 -4 -10 3 -10 14 0 25 6 27 13 6z m-3686
-61 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-47 -14 c0 -5 -7
-10 -15 -10 -8 0 -15 -4 -15 -8 0 -5 -17 -17 -39 -28 -32 -15 -36 -20 -25 -32
8 -7 14 -27 14 -43 0 -17 5 -29 13 -29 22 0 55 -79 34 -81 -7 -1 -1 -4 13 -8
25 -8 25 -8 -10 -24 -48 -23 -5 -16 70 11 105 38 125 33 30 -8 -52 -23 -106
-45 -120 -49 -14 -5 -95 -39 -180 -76 -85 -37 -191 -83 -235 -102 -200 -85
-529 -257 -758 -397 -81 -49 -111 -57 -57 -15 17 13 43 34 58 46 15 13 31 23
36 23 5 0 2 7 -5 17 -13 15 -11 16 16 9 22 -5 26 -4 15 4 -8 5 -27 7 -42 4
-23 -4 -28 -2 -28 13 0 10 9 24 20 31 16 10 20 23 20 67 0 30 4 55 10 55 5 0
19 20 30 43 17 35 19 49 10 71 -16 42 -13 46 35 46 31 0 45 4 45 13 0 8 11 24
25 37 18 17 22 27 14 36 -6 7 -6 14 -1 18 6 3 15 -1 22 -9 15 -18 30 -19 30
-2 0 20 16 38 36 41 14 3 18 11 17 31 -2 24 1 27 23 22 27 -5 64 24 64 50 0 7
6 10 14 7 8 -3 26 2 41 12 21 14 26 24 23 46 -3 20 0 29 12 33 22 7 52 -4 44
-16 -3 -5 2 -9 10 -9 21 0 20 26 -1 39 -14 8 -8 9 23 5 37 -5 43 -4 49 15 3
11 4 25 1 30 -3 5 15 19 40 30 38 18 51 20 78 11 17 -5 40 -19 50 -31 17 -20
17 -21 -1 -35 -16 -13 -7 -14 77 -8 52 4 96 11 98 15 2 5 16 6 30 3 22 -5 24
-3 12 6 -12 10 -10 11 10 7 17 -4 52 8 110 38 87 45 110 52 110 35z m-400 -20
c13 -9 13 -11 0 -20 -22 -15 -30 -12 -30 10 0 22 8 25 30 10z m347 -46 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m6955 -36 c63 -9 75 -14 67
-25 -6 -7 -18 -13 -26 -13 -8 0 -12 -4 -8 -9 11 -19 -13 -20 -71 -1 -70 22
-134 48 -134 55 0 9 94 5 172 -7z m646 -81 c120 -78 127 -81 137 -78 5 1 7 -1
3 -5 -4 -4 52 -48 125 -98 84 -58 174 -132 249 -205 109 -106 185 -201 171
-215 -4 -3 -1 -6 5 -6 10 0 62 -78 62 -94 0 -4 -17 9 -37 28 -21 20 -41 36
-45 36 -5 0 -8 -15 -8 -34 0 -19 -6 -36 -12 -38 -10 -4 -10 -10 -1 -31 8 -16
9 -27 3 -27 -6 0 -10 -5 -10 -11 0 -5 5 -7 12 -3 7 4 8 3 4 -5 -5 -7 3 -23 20
-39 50 -50 145 -174 170 -223 29 -58 25 -65 -7 -11 -63 103 -168 207 -303 300
-50 34 -98 68 -106 75 -32 26 -178 117 -235 147 -33 17 -71 40 -85 51 -25 19
-25 19 25 0 28 -11 83 -36 123 -55 40 -20 74 -36 76 -36 2 0 3 8 2 17 -1 13
11 20 42 27 35 7 42 13 42 32 0 17 6 24 19 24 29 0 35 30 10 57 -13 12 -18 23
-12 23 6 0 16 -7 23 -16 8 -8 23 -20 34 -26 30 -15 -125 137 -219 214 -90 74
-317 236 -376 270 -21 12 -39 25 -39 30 0 9 44 -15 138 -75z m-8328 -7 c0 -5
-8 -10 -17 -10 -15 0 -16 2 -3 10 19 12 20 12 20 0z m3280 -36 c0 -3 -7 -1
-15 6 -8 7 -15 17 -15 22 0 5 7 3 15 -6 8 -8 15 -18 15 -22z m1540 27 c0 -5
-7 -14 -15 -21 -12 -10 -15 -10 -15 2 0 8 3 18 7 21 9 10 23 9 23 -2z m2010
-45 c128 -33 201 -53 223 -61 19 -8 24 10 5 19 -24 10 47 -7 102 -25 30 -9 96
-33 147 -53 51 -20 98 -36 105 -36 16 0 -76 44 -158 75 -75 28 -127 55 -121
61 2 3 15 0 28 -5 13 -6 87 -34 164 -62 149 -55 412 -169 579 -250 105 -51
119 -68 19 -23 -141 64 -253 108 -259 102 -2 -3 35 -22 83 -43 48 -21 115 -50
148 -65 256 -118 303 -136 261 -105 -56 42 70 -17 232 -109 45 -25 84 -46 87
-46 9 0 110 -64 113 -72 2 -4 8 -8 13 -8 9 0 110 -60 119 -70 3 -4 32 -26 65
-51 129 -95 323 -286 377 -370 20 -31 41 -60 47 -63 5 -4 8 -13 4 -21 -3 -8 0
-15 6 -15 6 0 8 -7 4 -17 -4 -9 -2 -14 3 -10 6 3 16 -14 23 -39 7 -24 16 -44
20 -44 13 0 64 -164 66 -215 0 -22 3 -47 7 -55 6 -18 28 -123 39 -195 4 -27 7
-102 7 -165 l-1 -115 -13 155 c-30 326 -117 569 -280 771 -64 79 -173 183
-234 224 -25 16 -61 42 -80 56 -19 15 -51 35 -70 45 -19 11 -37 22 -40 25 -10
12 -228 148 -315 196 -101 57 -399 203 -520 255 -354 155 -640 268 -1052 418
-58 20 -75 30 -55 30 4 0 50 -11 102 -24z m-5675 -11 c0 -14 -4 -25 -8 -25 -5
0 -15 -7 -23 -15 -18 -18 -16 -18 24 -4 22 7 36 7 49 0 16 -9 15 -11 -7 -12
l-25 -1 25 -7 c24 -7 24 -8 -15 -28 -22 -11 -83 -37 -135 -58 -408 -159 -863
-370 -1130 -523 -100 -57 -271 -162 -280 -172 -3 -3 -20 -14 -39 -24 -19 -11
-42 -25 -50 -32 -9 -7 -40 -30 -69 -52 -189 -140 -334 -314 -415 -498 -22 -50
-63 -198 -83 -301 -5 -27 -20 -31 -22 -5 -2 36 22 181 30 176 4 -3 5 1 2 9 -8
22 51 191 96 275 95 176 264 365 465 518 211 161 720 446 1026 575 212 89 307
127 439 175 80 29 145 53 145 54 0 0 0 -11 0 -25z m1919 9 c3 -8 2 -12 -4 -9
-6 3 -10 10 -10 16 0 14 7 11 14 -7z m1613 -16 c-3 -7 -5 -2 -5 12 0 14 2 19
5 13 2 -7 2 -19 0 -25z m123 13 c0 -5 -11 -12 -24 -15 -13 -3 -32 -8 -43 -11
-10 -4 -2 3 17 13 41 23 50 25 50 13z m-110 -35 c0 -3 -4 -8 -10 -11 -5 -3
-10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-1349 -43 c13 -15 12 -15 -8
-4 -24 12 -29 21 -14 21 5 0 15 -7 22 -17z m174 -44 c-3 -22 1 -28 22 -34 21
-5 23 -8 12 -21 -14 -17 -14 -18 31 -37 30 -13 32 -15 11 -16 -20 -1 -22 -3
-10 -17 11 -14 10 -16 -11 -12 -19 2 -25 -1 -24 -14 1 -10 -3 -15 -8 -12 -11
7 -70 -15 -80 -30 -5 -7 -11 -7 -20 2 -6 6 -20 12 -31 12 -27 0 -74 60 -62 80
3 5 -13 15 -35 21 -24 7 -36 15 -29 20 8 4 2 12 -17 23 -16 8 -24 15 -19 15 6
0 21 -6 35 -14 32 -18 70 -19 70 -1 0 8 7 17 16 20 13 5 14 9 4 21 -18 21 -6
29 20 15 18 -9 24 -9 30 1 7 10 14 10 39 -1 18 -7 35 -9 39 -5 4 4 1 10 -5 12
-7 3 -13 9 -13 14 0 5 9 4 19 -3 13 -8 18 -20 16 -39z m-389 2 c17 -10 40 -21
50 -24 18 -4 18 -5 -1 -6 -11 0 -38 10 -60 24 -22 13 -35 24 -30 25 6 0 24 -9
41 -19z m104 -41 c8 -5 11 -10 5 -10 -5 0 -17 5 -25 10 -8 5 -10 10 -5 10 6 0
17 -5 25 -10z m1083 -41 c4 -16 3 -18 -9 -8 -16 13 -19 29 -5 29 5 0 11 -9 14
-21z m24 -61 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-560 6
c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m4559 -105 c8 -14 -10
-11 -32 6 -18 13 -18 14 4 8 12 -3 25 -9 28 -14z m-294 -40 c27 -17 28 -19 8
-13 -13 3 -30 13 -38 20 -19 20 -7 17 30 -7z m955 -211 c-3 -8 -6 -5 -6 6 -1
11 2 17 5 13 3 -3 4 -12 1 -19z m-4514 -105 c37 -6 38 -7 35 -42 l-3 -36 -50
0 c-45 0 -51 -3 -63 -29 -18 -36 -6 -46 56 -46 43 0 43 0 40 -32 -3 -32 -4
-33 -53 -33 l-50 0 -5 -130 -5 -130 -52 -3 -53 -3 0 135 0 136 -24 0 c-19 0
-25 6 -28 30 -5 36 -3 40 34 40 25 0 28 3 28 33 0 87 75 130 193 110z m-993
-114 l0 -51 33 2 c63 4 67 2 67 -30 0 -28 -3 -30 -50 -36 l-50 -7 0 -88 c0
-77 2 -90 19 -99 13 -7 28 -7 46 0 36 14 35 15 35 -29 0 -45 -11 -51 -97 -51
-40 0 -58 5 -80 24 -26 23 -28 28 -31 130 -4 104 -5 106 -28 106 -21 0 -24 5
-24 35 0 30 3 35 24 35 23 0 25 5 28 47 3 44 5 48 33 54 72 16 75 14 75 -42z
m2330 -47 l0 -45 -47 7 c-27 3 -76 9 -110 13 l-63 6 0 -50 0 -49 90 -11 c50
-6 93 -13 96 -16 3 -3 2 -22 -2 -42 -6 -35 -8 -36 -38 -31 -17 3 -59 8 -93 12
l-61 6 -4 -55 -3 -56 35 -5 c19 -3 68 -10 108 -16 l72 -12 0 -33 c0 -19 -5
-37 -10 -40 -6 -4 -79 1 -161 11 -109 12 -152 21 -156 32 -6 13 16 441 23 453
1 3 75 -4 163 -15 l161 -19 0 -45z m-3010 28 c98 -50 131 -145 94 -269 -21
-72 -73 -126 -144 -150 -62 -22 -228 -47 -238 -36 -4 4 -9 108 -12 231 l-5
224 30 5 c128 21 228 19 275 -5z m1090 -28 c50 -25 60 -52 60 -169 0 -57 4
-105 10 -108 6 -3 10 -15 10 -26 0 -16 -7 -19 -54 -19 -39 0 -55 4 -60 15 -5
13 -10 12 -38 -5 -62 -37 -168 -17 -182 34 -20 74 16 129 97 145 29 6 65 12
81 14 34 2 42 16 23 41 -17 24 -82 25 -126 3 -29 -14 -32 -14 -40 1 -23 43
-18 54 34 73 65 23 141 24 185 1z m903 -7 c96 -40 133 -177 70 -264 -49 -66
-164 -90 -246 -50 -120 58 -132 225 -22 301 33 22 51 27 101 28 34 0 77 -7 97
-15z m-1557 -48 c17 -20 22 -43 27 -133 4 -59 12 -113 17 -118 6 -6 10 -18 10
-27 0 -23 -90 -34 -106 -13 -15 18 -21 18 -46 -6 -26 -24 -101 -36 -134 -21
-33 15 -57 72 -48 117 8 46 58 79 138 93 33 6 61 11 63 11 2 0 3 9 3 20 0 42
-65 48 -134 13 -31 -16 -41 -11 -51 28 -5 22 -2 27 32 42 89 40 191 38 229 -6z
m1831 32 c6 -6 9 -18 6 -25 -7 -20 8 -17 37 6 31 24 98 27 106 5 4 -8 3 -30 0
-49 -6 -33 -7 -33 -51 -28 -31 3 -52 0 -69 -11 -22 -15 -24 -24 -28 -116 -2
-55 -7 -103 -10 -107 -4 -3 -28 -2 -55 2 l-47 9 2 50 c1 28 5 101 8 163 l6
112 42 0 c23 0 47 -5 53 -11z m3561 -71 c-2 -13 -10 -23 -18 -23 -8 0 -16 10
-18 23 -3 17 2 22 18 22 16 0 21 -5 18 -22z m-2690 -17 c8 -4 26 -59 41 -122
l28 -114 40 85 c22 47 43 93 47 104 5 16 14 18 52 13 53 -6 62 -12 47 -35 -6
-10 -41 -76 -78 -147 -37 -72 -68 -131 -70 -133 -1 -2 -26 0 -54 4 -34 4 -52
12 -55 23 -39 149 -61 226 -76 274 l-19 57 42 0 c23 0 48 -4 55 -9z m-4368
-65 c0 -42 -1 -44 -36 -50 -19 -4 -41 -9 -49 -12 -8 -4 -15 5 -20 25 -10 47 1
69 38 74 70 9 67 10 67 -37z m210 -1 l0 -46 50 7 50 7 0 -31 c0 -28 -4 -31
-51 -42 l-51 -13 7 -86 c4 -47 9 -90 12 -94 6 -9 46 -5 76 8 14 6 17 2 17 -29
0 -31 -4 -38 -34 -50 -104 -43 -166 -15 -166 77 0 28 -3 75 -6 104 -6 48 -8
51 -33 50 -23 -2 -26 2 -26 28 0 23 5 30 25 35 21 5 26 13 30 49 4 36 10 45
35 56 55 25 65 20 65 -30z m431 -102 c-64 -179 -109 -300 -120 -322 -10 -19
-101 -45 -113 -32 -5 4 8 32 27 61 19 30 35 61 35 69 0 7 -23 61 -51 120 -28
58 -59 123 -69 143 l-18 37 50 10 c27 6 50 11 52 11 2 0 21 -43 42 -95 22 -52
41 -95 44 -95 3 0 19 48 36 107 33 115 37 119 106 122 l27 1 -48 -137z m-826
-50 c4 -87 8 -194 8 -237 l2 -79 -47 -13 c-27 -6 -48 -11 -49 -10 -3 5 -21
348 -24 460 0 5 16 15 35 22 70 25 67 31 75 -143z m5079 117 c54 -35 76 -76
76 -145 l0 -46 -37 7 c-21 3 -69 12 -106 20 -38 8 -73 14 -78 14 -17 0 -9 -36
12 -59 31 -33 67 -43 127 -36 l52 6 0 -35 c0 -34 -2 -35 -45 -42 -99 -14 -201
31 -241 108 -19 37 -17 126 4 166 42 79 148 97 236 42z m219 -41 c24 -6 37
-15 34 -23 -3 -7 -1 -19 4 -27 5 -9 9 -10 9 -2 0 17 63 35 94 27 27 -7 30 -13
20 -62 -6 -30 -7 -30 -58 -25 -67 7 -76 -4 -89 -115 -5 -48 -13 -91 -17 -95
-4 -5 -26 -3 -49 3 -49 13 -49 12 -26 195 8 65 15 123 15 127 0 11 18 10 63
-3z m-5102 -185 c3 -87 5 -160 5 -161 -4 -5 -96 -26 -99 -22 -2 2 -7 76 -11
165 l-6 161 43 10 c23 6 47 10 52 8 6 -1 13 -68 16 -161z m5353 131 c40 -8 40
-8 72 -156 l17 -82 49 98 c39 78 52 95 66 90 9 -3 29 -9 45 -12 15 -3 27 -9
27 -14 0 -5 -50 -92 -110 -194 -120 -200 -118 -198 -191 -174 -19 7 -35 13
-37 15 -8 6 20 44 28 39 5 -3 20 10 34 28 l26 34 -44 172 c-31 121 -40 171
-31 167 8 -3 30 -8 49 -11z m-5768 -108 c24 -21 27 -33 35 -123 5 -54 14 -109
21 -122 15 -28 4 -37 -55 -46 -28 -5 -43 -3 -48 6 -6 10 -12 8 -23 -8 -34 -48
-130 -69 -174 -38 -17 11 -22 25 -22 57 0 63 30 103 103 137 34 17 67 30 74
30 17 0 24 15 17 34 -12 30 -93 15 -138 -26 -23 -21 -32 -17 -40 18 -8 31 17
55 89 83 70 28 127 27 161 -2z m6245 -9 c45 -15 106 -63 124 -99 19 -36 19
-120 1 -164 -30 -70 -121 -95 -208 -55 -84 38 -118 86 -118 171 0 116 93 184
201 147z m-6586 -79 c2 -13 6 -85 10 -160 l6 -137 -47 -16 c-44 -15 -46 -15
-51 4 -5 17 -7 16 -30 -10 -49 -59 -130 -78 -170 -40 -24 22 -32 62 -35 193
l-3 89 48 18 c35 13 49 15 52 7 2 -7 5 -58 7 -115 2 -78 7 -105 18 -112 23
-15 36 -12 70 17 l32 26 -3 113 c-2 65 1 118 6 123 10 9 77 30 83 26 2 -2 5
-13 7 -26z m3335 -9 c0 -5 -16 -10 -36 -10 -21 0 -33 4 -29 10 3 6 19 10 36
10 16 0 29 -4 29 -10z m3519 -1 c19 -7 36 -22 42 -36 7 -20 12 -22 28 -13 31
16 73 12 116 -13 58 -33 67 -67 49 -187 -24 -167 -22 -163 -88 -136 l-33 14
13 78 c18 109 17 159 -2 174 -20 18 -74 17 -84 -1 -5 -7 -15 -53 -21 -101 -7
-49 -16 -93 -20 -99 -10 -16 -89 10 -89 30 -1 33 44 301 51 301 3 0 21 -5 38
-11z m-7283 -72 c69 -75 68 -223 -3 -321 -33 -47 -34 -50 -17 -63 10 -7 33
-13 51 -13 18 0 33 -4 33 -9 0 -16 -82 -81 -102 -81 -10 0 -38 10 -61 22 -33
18 -59 23 -124 23 -73 0 -84 3 -108 25 -39 35 -55 80 -55 150 0 86 16 139 58
196 91 120 252 155 328 71z m7803 -110 c56 -37 84 -87 85 -152 0 -30 -3 -57
-6 -61 -4 -4 -52 10 -108 31 -55 21 -103 35 -107 31 -13 -13 31 -80 62 -96 17
-8 49 -14 72 -15 38 0 42 -2 46 -30 3 -16 3 -33 0 -37 -14 -24 -149 12 -203
54 -90 71 -92 243 -2 293 39 22 112 14 161 -18z m-3674 -212 c50 -3 144 -10
210 -16 66 -5 170 -12 230 -15 61 -3 164 -14 230 -24 156 -25 172 -28 225 -41
25 -6 77 -13 115 -16 39 -3 72 -8 75 -12 8 -10 96 -31 129 -31 16 0 31 -4 33
-9 2 -5 46 -17 98 -25 84 -13 134 -24 305 -67 22 -6 65 -15 95 -20 30 -6 57
-14 58 -19 2 -6 10 -10 19 -10 8 0 43 -13 77 -29 35 -16 97 -36 140 -45 45 -9
85 -24 98 -36 12 -11 36 -20 53 -20 17 0 57 -13 90 -30 33 -16 65 -30 72 -30
6 0 13 -4 15 -9 2 -6 22 -11 45 -12 23 -2 40 -6 37 -11 -3 -4 8 -10 23 -14 15
-3 42 -12 60 -20 17 -8 40 -14 52 -14 12 0 21 -6 21 -15 0 -8 9 -15 19 -15 11
0 28 -3 38 -6 15 -5 15 -4 3 5 -13 9 -12 11 5 11 22 1 -97 61 -124 63 -23 1
-48 27 -28 27 25 0 121 -20 142 -29 11 -5 41 -16 67 -26 53 -18 109 -54 115
-72 3 -9 -9 -11 -44 -8 -26 2 -52 4 -58 5 -5 0 -3 5 5 10 11 8 6 10 -20 8 -59
-5 -40 -24 65 -66 27 -11 51 -25 53 -30 1 -5 -15 -12 -38 -16 -22 -3 -40 -11
-40 -16 0 -6 -11 -10 -25 -10 -16 0 -25 6 -25 15 0 8 -7 15 -15 15 -26 0 -18
-47 9 -54 14 -3 26 -16 30 -31 4 -17 13 -25 27 -25 14 0 19 -5 16 -14 -3 -8 0
-17 7 -19 7 -3 16 -15 19 -26 4 -17 1 -21 -21 -21 -14 0 -22 -3 -19 -7 4 -3
186 -9 404 -13 l398 -7 -428 -1 c-283 -1 -426 -5 -422 -12 4 -6 154 -10 416
-10 l410 0 -3 -106 -3 -106 -145 -2 -145 -1 -3 -442 -2 -443 -115 0 -115 0 0
445 0 446 -152 -2 -152 -1 -3 89 c-3 95 -11 153 -19 153 -3 0 -26 -18 -51 -40
-25 -22 -49 -37 -53 -35 -5 3 -11 19 -15 35 l-7 30 -101 -1 c-79 -1 -95 -3
-72 -10 17 -5 57 -9 89 -7 l60 2 47 -145 c26 -79 106 -323 178 -543 72 -219
131 -402 131 -407 0 -5 -56 -9 -125 -9 -112 0 -125 2 -125 18 0 9 -16 69 -34
132 l-33 115 -189 2 -189 3 -38 -123 c-21 -67 -38 -128 -37 -134 0 -10 -30
-13 -120 -13 -66 0 -120 3 -120 7 0 5 21 71 46 148 79 243 92 286 143 465 28
96 53 195 56 220 l5 45 -21 -53 c-12 -29 -23 -51 -25 -50 -1 2 5 32 15 68 10
36 19 89 19 118 l2 53 -38 -28 c-56 -42 -70 -60 -86 -117 -12 -40 -20 -52 -35
-52 -11 0 -18 3 -16 6 2 4 -5 14 -16 23 -21 18 -27 9 -7 -11 7 -7 8 -12 2 -12
-5 0 -21 19 -36 43 -81 125 -206 209 -352 236 -33 6 -150 10 -260 9 l-201 -1
205 -8 c251 -10 306 -19 396 -63 178 -88 274 -281 260 -521 -10 -170 -52 -280
-145 -374 -68 -70 -132 -108 -220 -133 -54 -15 -103 -18 -288 -18 l-223 0 -1
448 c-2 482 -8 663 -24 669 -6 2 -34 -36 -63 -84 -51 -85 -52 -89 -52 -163 l0
-77 -31 5 c-17 2 -33 11 -36 18 -3 8 -11 14 -19 14 -8 0 -14 6 -14 13 0 9 -2
9 -9 -1 -6 -10 -11 -6 -19 15 -9 24 -76 215 -87 251 -3 9 -38 11 -137 10
l-133 -2 120 -6 120 -5 52 -155 c76 -225 275 -860 287 -917 l8 -33 -120 0
-119 0 -31 108 c-16 59 -33 119 -36 135 l-6 27 -182 -2 -181 -3 -35 -120 c-19
-66 -36 -126 -38 -132 -2 -10 -36 -13 -125 -13 -93 0 -120 3 -116 13 5 13 70
223 122 392 18 61 70 229 114 374 81 263 104 356 83 336 -6 -5 -20 -37 -31
-70 -12 -33 -37 -105 -57 -160 -19 -55 -38 -108 -41 -118 -5 -15 -8 -16 -14
-5 -7 10 -9 10 -9 1 0 -7 -7 -13 -15 -13 -8 0 -24 -9 -35 -20 -28 -28 -49 -25
-61 7 -7 20 -12 24 -18 14 -18 -28 -24 16 -29 191 -4 164 -6 178 -23 178 -18
0 -18 -24 -19 -556 0 -306 -2 -559 -4 -563 -2 -3 -57 -4 -121 -1 l-117 5 2
223 1 222 -201 0 -200 0 0 -225 0 -225 -124 0 -123 0 1 53 c5 250 -6 1057 -14
1057 -5 0 -10 -17 -10 -39 0 -21 -3 -66 -6 -100 -6 -55 -9 -61 -30 -61 -12 0
-25 -6 -27 -12 -4 -10 -8 -9 -17 2 -7 10 -13 11 -16 4 -3 -6 -35 19 -72 56
-60 59 -129 107 -139 96 -2 -2 12 -13 31 -25 48 -30 125 -117 158 -178 43 -78
61 -164 61 -288 1 -289 -136 -486 -380 -550 -43 -11 -116 -15 -286 -15 l-228
0 1 143 c3 506 -1 977 -9 977 -6 0 -11 -17 -13 -37 l-3 -38 -28 44 c-51 78
-53 70 -65 -429 -9 -361 -11 -377 -61 -481 -25 -52 -88 -117 -144 -148 -116
-64 -302 -67 -436 -5 -67 30 -102 62 -146 129 -66 101 -68 118 -74 559 -5 306
-9 400 -18 404 -10 3 -13 -14 -13 -60 0 -51 -3 -65 -15 -65 -8 0 -15 9 -15 21
0 12 -3 16 -8 10 -4 -6 -16 -14 -27 -18 -16 -6 -17 -9 -5 -16 8 -6 10 -10 4
-10 -6 0 -17 6 -23 14 -14 16 -51 28 -51 16 0 -5 8 -14 18 -19 9 -6 12 -11 6
-11 -6 0 -32 17 -57 37 -33 26 -42 40 -34 46 8 6 6 7 -6 3 -11 -4 -31 7 -56
30 -41 36 -56 33 -45 -10 3 -14 7 -42 9 -63 1 -21 39 -144 85 -273 45 -129 86
-251 92 -270 6 -19 42 -127 80 -240 38 -113 72 -213 75 -222 4 -15 -8 -17
-121 -20 l-127 -3 -29 95 c-16 52 -34 114 -41 138 l-12 42 -189 0 c-142 0
-190 -3 -193 -12 -2 -7 -13 -44 -24 -83 -12 -38 -29 -94 -38 -122 l-17 -53
-126 0 -126 0 134 403 c193 581 232 706 225 723 -3 8 -2 14 3 13 22 -4 237 4
222 8 -11 3 -18 14 -18 29 0 14 4 22 10 19 6 -3 10 3 10 14 0 14 -6 21 -18 21
-24 0 -64 70 -44 77 6 3 12 11 12 18 0 7 7 15 15 19 8 3 15 15 15 26 0 11 7
20 15 20 9 0 18 7 21 15 4 8 15 15 25 15 14 0 19 7 19 30 0 28 -2 30 -39 30
-22 0 -41 -4 -43 -10 -1 -5 -25 -13 -53 -17 -45 -6 -49 -5 -37 10 7 8 31 18
53 22 21 4 39 11 39 17 0 7 19 9 54 5 32 -3 58 -1 64 5 6 6 22 12 36 13 14 2
50 15 80 29 30 14 62 26 70 26 9 0 16 4 16 10 0 5 18 13 40 16 22 4 40 10 40
15 0 5 18 9 40 9 22 0 40 4 40 9 0 5 18 11 40 15 22 3 40 10 40 15 0 9 67 26
84 22 4 -1 13 2 20 7 6 5 36 17 66 27 30 10 75 29 99 42 24 12 56 23 71 23 15
0 49 10 76 21 26 12 88 27 138 34 50 7 123 21 161 29 212 50 414 86 620 112
72 9 159 21 195 26 36 5 90 11 120 13 30 3 125 12 210 21 318 31 616 38 895
19z m-5601 -185 l-13 -145 5 115 c4 107 13 185 19 178 2 -2 -3 -68 -11 -148z
m8253 -406 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m1640 -94
c3 -10 2 -11 -4 -4 -4 6 -15 14 -23 17 -11 5 -9 6 4 4 11 -1 21 -9 23 -17z
m-8805 -65 c-4 -21 -7 -23 -25 -13 -20 10 -20 11 -2 24 27 20 33 17 27 -11z
m768 -30 c0 -5 -55 -35 -65 -35 -14 0 -3 18 18 28 24 11 47 15 47 7z m-442
-163 c13 -4 -119 -5 -294 -4 -228 3 -314 1 -310 -7 5 -8 97 -11 295 -11 307 0
359 -7 426 -53 114 -81 159 -220 121 -379 -23 -95 -80 -167 -157 -198 -18 -7
-35 -14 -37 -15 -2 -2 24 -51 110 -205 83 -147 117 -212 123 -230 6 -19 2 -20
-123 -20 l-130 0 -53 98 c-30 54 -79 146 -109 205 l-55 107 -87 0 -88 0 0
-205 c0 -130 -4 -205 -10 -205 -5 -1 -61 -1 -122 -1 l-113 0 -5 565 -5 566
300 -1 c165 -1 310 -4 323 -7z m59 -18 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11
1 17 -2 13 -5z m-1101 -575 c-8 -35 -18 -94 -21 -132 -8 -78 -20 -94 -30 -38
-10 59 22 205 51 234 14 14 14 0 0 -64z m-126 -269 c0 -5 -2 -10 -4 -10 -3 0
-8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z m40 -49 c0 -5 3 -18 7 -28 6
-17 6 -17 -10 -1 -19 18 -22 38 -7 38 6 0 10 -4 10 -9z m-33 -23 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m322 -118 c12 -22 18 -40 13 -40 -5 0
-15 12 -22 28 -8 15 -21 35 -29 45 -13 16 -13 17 0 12 9 -3 26 -24 38 -45z
m331 -369 c81 -77 98 -111 28 -54 -51 41 -148 136 -148 146 0 15 35 -12 120
-92z m315 59 c37 -39 15 -39 -27 0 -22 20 -28 30 -17 30 8 0 28 -13 44 -30z
m4015 15 c7 -8 18 -15 24 -15 6 0 32 -22 58 -48 40 -42 56 -51 116 -65 38 -9
84 -17 101 -17 17 0 31 -3 31 -7 0 -5 47 -9 105 -11 69 -2 105 1 105 7 0 6 11
11 25 11 27 0 89 37 139 82 33 30 121 54 164 44 44 -11 82 -28 82 -37 0 -5 8
-9 18 -9 11 0 27 -9 37 -20 10 -11 24 -20 32 -20 7 0 13 -4 13 -8 0 -11 60
-32 96 -33 29 -1 29 -1 4 -9 -18 -6 -3 -8 50 -9 42 -1 80 3 85 7 27 24 100 33
193 25 124 -10 363 -6 376 7 11 11 59 14 69 4 4 -4 21 -8 39 -10 18 -2 53 -7
78 -11 44 -8 43 -8 -35 -14 -44 -3 42 -5 190 -6 149 0 258 2 243 4 -29 4 -40
33 -13 33 8 0 39 11 68 26 46 22 56 24 92 14 101 -28 145 -44 145 -52 0 -4 7
-8 16 -8 9 0 28 -9 43 -19 14 -11 52 -24 84 -30 31 -5 68 -18 81 -26 14 -9 28
-16 31 -15 17 5 64 -14 67 -27 4 -18 76 -45 80 -31 2 6 15 -1 28 -16 14 -14
31 -26 38 -26 6 0 12 -11 12 -25 0 -17 5 -25 18 -25 10 0 23 -5 29 -11 9 -9
20 -9 40 -2 69 26 112 35 132 28 29 -9 22 -27 -15 -37 -17 -4 -50 -31 -79 -65
-27 -31 -75 -83 -105 -114 -30 -31 -75 -80 -100 -108 l-45 -52 -53 4 c-75 5
-81 22 -30 74 l42 43 -53 0 c-51 0 -55 -2 -95 -47 -165 -191 -264 -274 -374
-316 -55 -21 -74 -22 -702 -27 l-645 -6 480 -3 c324 -3 441 -7 360 -11 -136
-8 -3692 -13 -3684 -6 5 5 383 13 894 18 171 1 -160 5 -735 8 l-1045 5 -42 23
c-23 12 -47 22 -53 22 -5 0 -10 5 -10 10 0 6 -7 10 -16 10 -18 0 -248 230
-285 285 -23 33 -27 35 -84 35 l-60 -1 65 -59 c36 -33 71 -60 78 -60 6 0 12
-5 12 -11 0 -5 5 -7 12 -3 8 5 9 2 5 -10 -4 -10 -3 -15 3 -11 5 3 25 -11 44
-31 22 -23 39 -33 47 -28 8 5 11 2 7 -8 -4 -10 5 -24 24 -38 27 -20 30 -20 24
-5 -5 15 -4 16 9 5 8 -7 12 -16 9 -21 -3 -5 3 -6 12 -2 14 5 16 3 11 -11 -5
-14 -3 -16 12 -11 13 4 18 1 17 -10 -1 -11 14 -22 44 -32 25 -8 50 -19 55 -23
19 -14 71 -23 175 -30 l105 -7 -105 -1 c-181 -3 -287 40 -425 173 -56 54 -59
55 -94 45 -20 -5 -55 -21 -79 -35 -23 -13 -49 -22 -57 -19 -8 4 -15 2 -15 -4
0 -5 -7 -12 -15 -16 -10 -4 -23 8 -40 34 -28 44 -53 76 -73 94 -37 31 -52 51
-42 54 13 5 13 39 0 47 -5 3 -10 15 -10 26 0 10 -7 19 -15 19 -8 0 -15 6 -15
13 0 15 -37 50 -64 60 -12 5 -15 13 -11 28 5 15 2 22 -14 26 -12 3 -21 9 -21
14 0 5 -7 9 -15 9 -8 0 -15 4 -15 9 0 5 -8 11 -17 15 -10 3 -30 14 -44 23 -30
20 -201 127 -254 158 -44 27 -95 72 -95 85 0 15 49 1 92 -27 21 -12 40 -23 42
-23 3 0 47 -25 98 -56 50 -31 104 -60 118 -66 14 -5 53 -23 88 -40 53 -27 65
-29 74 -17 8 11 9 11 4 -3 -3 -12 0 -18 9 -18 8 0 15 5 15 10 0 16 2 23 11 48
6 15 4 37 -6 65 -20 57 -20 57 23 57 21 0 43 5 50 12 6 6 36 11 67 10 30 -1
55 3 55 8 0 5 16 14 35 21 19 7 37 21 41 31 3 10 9 18 14 18 5 0 10 8 12 18 3
14 15 17 68 19 141 4 148 3 194 -27 26 -18 51 -28 60 -24 9 3 16 1 16 -5 0 -6
7 -11 16 -11 14 0 14 -3 4 -15 -15 -18 -17 -18 50 2 46 13 126 17 465 23 226
3 394 7 375 9 -29 2 -22 6 45 21 87 20 150 44 160 60 8 12 107 13 120 1 6 -5
36 -18 68 -30 49 -18 80 -21 210 -21 192 0 297 17 426 69 56 23 116 41 134 41
31 -1 67 -19 67 -35 0 -4 20 -27 44 -51 42 -43 45 -44 107 -44 90 0 131 14
171 58 59 66 117 100 169 101 30 1 51 -4 59 -14z m-4880 -87 c0 -5 -4 -8 -8
-8 -9 0 -42 53 -42 67 1 10 50 -49 50 -59z m2888 -62 c3 -3 -43 -6 -102 -6
-59 0 -105 3 -102 8 5 8 195 7 204 -2z m-2498 -96 c0 -5 -4 -10 -10 -10 -5 0
-10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m87 -66 c-3 -3 -12 -4 -19 -1
-8 3 -5 6 6 6 11 1 17 -2 13 -5z m390 -11 c-16 -16 -18 -16 -34 0 -16 16 -15
17 17 17 32 0 33 -1 17 -17z m9210 -285 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2
-13 2 -33 0 -45z m-10440 -90 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1
-19z m8123 -77 c-32 -46 -160 -160 -205 -183 -101 -52 -117 -59 -120 -56 -2 2
24 18 58 36 34 17 78 45 97 62 19 17 56 47 81 68 25 20 57 52 70 69 30 41 48
44 19 4z m-8081 -176 c-1 -11 -9 18 -20 65 -10 47 -18 96 -18 110 1 14 9 -15
20 -65 10 -49 18 -99 18 -110z m-202 -177 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13
3 -3 4 -12 1 -19z m0 -90 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z
m8653 28 c0 -2 -9 -6 -20 -9 -11 -3 -18 -1 -14 4 5 9 34 13 34 5z m-8637 -126
c4 -56 3 -65 -3 -35 -9 40 -13 122 -6 114 2 -2 6 -38 9 -79z m3247 26 c0 -23
-4 -25 -52 -28 -49 -3 -53 -5 -53 -28 0 -22 5 -25 43 -28 37 -3 42 -6 42 -28
0 -22 -4 -24 -46 -24 l-47 0 5 -50 c5 -48 4 -50 -21 -50 l-26 0 1 123 c1 67 2
125 3 130 0 4 35 7 76 7 73 0 75 -1 75 -24z m760 4 c26 -26 25 -58 -2 -87
l-22 -23 22 -23 23 -22 5 23 c4 13 14 22 25 22 22 0 24 -18 7 -55 -10 -22 -8
-29 13 -51 l24 -27 -45 6 c-25 3 -59 1 -76 -5 -37 -13 -77 -5 -104 22 -27 27
-25 62 6 95 18 20 22 31 15 38 -6 6 -11 26 -11 43 0 58 78 86 120 44z m391 -9
c24 -30 24 -79 0 -105 -19 -21 -19 -21 5 -71 13 -27 24 -51 24 -52 0 -2 -12
-3 -28 -3 -23 0 -31 8 -50 50 -13 28 -30 50 -37 50 -11 0 -15 -13 -15 -50 0
-47 -2 -50 -25 -50 l-25 0 0 131 0 131 66 -4 c55 -3 70 -8 85 -27z m289 -101
l0 -130 -25 0 -25 0 0 130 0 130 25 0 25 0 0 -130z m88 107 c4 -20 -25 -34
-40 -19 -15 15 -1 44 19 40 10 -2 19 -11 21 -21z m272 -22 c0 -39 2 -45 16
-37 64 36 120 -68 79 -147 -18 -36 -33 -42 -95 -34 l-50 6 0 128 0 129 25 0
c23 0 25 -4 25 -45z m190 -85 l0 -130 -25 0 -25 0 0 130 0 130 25 0 25 0 0
-130z m487 97 c37 -36 44 -136 14 -184 -26 -41 -106 -66 -156 -47 -14 6 -16
24 -14 128 0 66 4 125 6 130 3 4 32 6 65 4 47 -3 64 -10 85 -31z m800 8 c28
-25 28 -25 8 -40 -12 -10 -21 -12 -23 -5 -6 16 -39 31 -56 24 -27 -10 -18 -41
15 -55 49 -20 89 -58 89 -84 0 -13 -11 -37 -24 -52 -20 -23 -32 -28 -71 -28
-39 0 -51 5 -71 28 -13 16 -22 33 -19 38 9 14 41 11 55 -7 8 -8 25 -14 39 -12
20 2 26 9 26 28 0 19 -7 26 -33 34 -18 5 -43 19 -57 32 -77 71 43 169 122 99z
m597 9 c8 -21 -1 -34 -25 -34 -12 0 -19 7 -19 18 0 34 33 45 44 16z m-3444
-39 c0 -18 5 -25 20 -25 13 0 20 -7 20 -20 0 -13 -7 -20 -20 -20 -17 0 -20 -7
-20 -49 0 -40 3 -50 20 -54 11 -3 20 -12 20 -20 0 -24 -38 -31 -65 -13 -22 14
-25 24 -25 76 0 33 -4 60 -10 60 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 8
10 18 0 10 3 22 7 25 3 4 15 7 25 7 13 0 18 -7 18 -25z m2350 0 c0 -18 5 -25
20 -25 26 0 26 -30 0 -37 -18 -5 -21 -12 -18 -57 2 -37 7 -51 18 -51 8 0 16
-8 18 -17 2 -10 -1 -18 -6 -18 -6 0 -17 -3 -25 -6 -9 -3 -25 4 -36 15 -16 16
-21 34 -21 76 0 30 -4 55 -10 55 -5 0 -10 9 -10 20 0 11 5 20 10 20 6 0 10 8
10 18 0 24 8 32 32 32 13 0 18 -7 18 -25z m3370 -97 c0 -81 4 -99 25 -136 14
-24 22 -48 19 -53 -13 -21 -40 -6 -60 34 -15 30 -40 55 -90 89 -76 51 -85 63
-54 73 14 4 33 -3 62 -24 23 -17 46 -31 50 -31 4 0 8 26 8 58 0 53 11 82 32
82 4 0 8 -42 8 -92z m-5832 60 c6 -6 12 -17 12 -24 0 -17 -32 -18 -47 -3 -7 7
-19 9 -28 5 -14 -5 -15 -9 -5 -21 7 -8 20 -15 29 -15 28 0 61 -30 61 -55 0
-27 -42 -65 -72 -65 -26 0 -78 31 -78 46 0 18 34 23 49 7 7 -8 20 -13 29 -11
30 6 22 25 -20 44 -34 15 -44 25 -46 47 -2 16 2 34 8 42 21 25 78 26 108 3z
m1845 -10 c20 -23 23 -78 5 -79 -7 -1 -29 0 -49 1 -44 2 -55 -11 -30 -34 16
-14 23 -15 45 -4 23 10 29 9 36 -2 22 -35 -50 -61 -98 -36 -16 8 -32 23 -36
31 -10 26 -7 94 5 116 22 42 89 46 122 7z m506 8 c5 -6 11 -46 13 -89 l3 -78
-25 2 c-14 2 -35 -1 -47 -5 -32 -10 -58 0 -72 30 -18 41 16 84 68 84 12 0 21
6 21 14 0 21 -20 30 -33 17 -18 -18 -47 -13 -47 9 0 13 9 22 28 26 15 3 32 7
37 8 16 4 43 -5 54 -18z m299 -1 c8 -7 15 -43 17 -89 l3 -78 -25 5 c-15 3 -39
0 -55 -5 -23 -8 -33 -7 -48 7 -42 38 -12 105 47 105 28 0 37 14 17 30 -11 10
-18 10 -26 2 -19 -19 -50 -15 -46 5 7 38 82 50 116 18z m1075 -3 c21 -19 22
-28 1 -36 -10 -4 -25 1 -35 10 -27 24 -49 2 -49 -47 0 -45 25 -67 51 -43 17
15 52 9 46 -9 -2 -6 -15 -19 -29 -30 -23 -17 -30 -18 -62 -7 -44 14 -56 35
-56 92 1 51 17 76 57 87 32 9 50 5 76 -17z m170 -1 c8 -9 18 -31 22 -48 6 -31
5 -33 -22 -34 -78 -2 -96 -11 -72 -35 13 -12 20 -13 43 -3 33 15 57 -1 37 -25
-21 -25 -67 -29 -100 -10 -61 36 -53 149 12 173 27 10 63 3 80 -18z m175 1
c19 -25 14 -35 -15 -28 -48 11 -56 11 -60 0 -2 -6 15 -16 37 -23 51 -15 70
-49 50 -86 -25 -47 -129 -42 -138 7 -4 23 30 33 45 13 7 -11 19 -15 32 -10 31
9 26 22 -14 35 -65 22 -79 79 -27 109 22 14 73 4 90 -17z m-4244 2 c11 -11 16
-35 16 -80 0 -35 0 -67 0 -71 0 -5 -23 -11 -52 -14 -66 -8 -98 9 -98 50 0 34
18 51 62 60 17 4 33 11 35 18 5 15 -28 26 -41 13 -14 -14 -46 -12 -46 3 0 24
24 37 66 37 25 0 49 -6 58 -16z m1189 -1 c8 -10 17 -31 19 -48 3 -30 2 -30
-49 -33 -55 -3 -68 -17 -38 -42 13 -11 20 -11 41 0 34 19 57 -2 31 -27 -27
-27 -94 -23 -118 6 -27 33 -26 107 3 138 27 29 87 32 111 6z m196 -73 c0 -89
-1 -90 -25 -90 -24 0 -24 1 -24 90 0 89 0 90 24 90 24 0 25 -1 25 -90z m165
68 c11 -15 16 -45 16 -91 0 -69 0 -69 -26 -64 -14 2 -39 0 -54 -6 -24 -9 -33
-8 -49 8 -25 21 -27 67 -6 85 8 7 29 15 47 19 17 4 33 11 35 18 6 17 -28 25
-46 10 -18 -16 -41 -12 -41 7 0 23 24 36 66 36 33 0 47 -5 58 -22z m1770 6
c33 -33 33 -103 0 -90 -21 8 -84 -3 -84 -15 0 -16 41 -32 53 -20 16 16 47 13
47 -4 0 -24 -45 -48 -79 -40 -45 10 -66 40 -66 95 0 62 23 90 76 90 21 0 45
-7 53 -16z m166 -5 c0 -12 -7 -19 -20 -19 -27 0 -40 -29 -40 -89 0 -48 -2 -51
-25 -51 -25 0 -25 1 -25 89 l0 89 55 0 c47 -1 55 -3 55 -19z m75 -34 c9 -30
18 -55 19 -55 2 0 11 25 21 55 13 41 22 55 36 55 25 0 24 -10 -7 -103 -24 -72
-28 -78 -52 -75 -22 3 -29 13 -48 70 -39 117 -38 108 -10 108 22 0 27 -7 41
-55z m175 -19 c0 -87 -5 -106 -31 -106 -17 0 -19 8 -19 90 0 89 0 90 25 90 24
0 25 -2 25 -74z m-5769 48 c7 -9 14 -41 15 -71 1 -30 4 -57 7 -60 3 -3 15 3
26 13 11 11 32 26 48 36 25 15 30 15 48 1 11 -8 16 -17 10 -19 -5 -3 -38 -23
-73 -45 -46 -29 -70 -53 -90 -89 -15 -27 -33 -50 -40 -50 -23 0 -24 27 -3 66
17 32 21 57 21 136 0 98 6 112 31 82z m1540 -34 c25 -14 24 -25 -3 -36 -31
-13 -755 1 -788 14 -29 12 -55 11 380 21 151 4 301 8 333 9 32 1 67 -3 78 -8z
m5699 -7 l115 -7 -70 -7 c-38 -4 -232 -10 -430 -15 -290 -6 -365 -5 -385 6
l-25 13 35 13 c27 10 106 12 340 8 168 -2 357 -8 420 -11z m615 -40 c3 -10 1
-19 -4 -21 -6 -2 -20 -11 -31 -20 -20 -17 -20 -18 29 -113 36 -71 46 -100 38
-108 -20 -20 -32 -10 -65 58 -19 38 -42 83 -53 101 -19 30 -21 31 -43 16 -21
-13 -26 -14 -37 0 -15 18 -14 19 73 65 85 45 84 44 93 22z m-7549 -82 c36 -22
59 -77 50 -122 -11 -54 -53 -107 -95 -120 -110 -33 -187 71 -132 178 40 80
110 105 177 64z m7404 -118 c30 -64 54 -119 53 -122 -1 -3 -10 -7 -20 -9 -15
-2 -30 21 -71 105 -29 59 -52 113 -52 120 0 10 14 20 30 22 3 0 30 -52 60
-116z m-7251 38 c12 -8 8 -24 -22 -98 -20 -49 -37 -94 -37 -100 0 -20 30 -43
56 -43 22 0 31 12 70 95 41 86 47 94 65 85 10 -6 19 -14 18 -18 -2 -26 -89
-180 -110 -195 -31 -22 -74 -17 -114 14 -36 29 -33 81 11 185 20 46 39 84 43
84 3 0 12 -4 20 -9z m7131 -16 c19 -21 22 -31 17 -69 -6 -44 -6 -46 38 -77 46
-33 49 -43 16 -52 -13 -3 -33 7 -60 29 -64 55 -86 43 -56 -29 19 -47 19 -57
-2 -57 -13 0 -33 32 -70 110 -29 60 -53 114 -53 120 0 16 73 49 111 50 25 0
42 -7 59 -25z m-3571 -75 c12 -33 26 -60 30 -60 5 0 16 20 26 45 9 26 22 44
29 42 23 -8 2 -106 -43 -194 -17 -34 -31 -66 -31 -72 0 -5 26 -15 58 -22 56
-12 113 -10 702 17 236 11 -215 -59 -602 -93 -59 -5 -68 -8 -68 -26 0 -11 -13
-32 -29 -46 -60 -54 -59 -53 -85 -36 -26 17 -28 16 -61 -30 -13 -19 -14 -17
-15 23 0 35 -6 48 -31 71 -17 16 -47 31 -68 35 -20 3 -119 17 -221 31 -102 13
-228 31 -280 40 -133 21 -346 66 -285 60 28 -3 149 -14 270 -26 219 -21 578
-29 623 -15 12 4 22 12 22 18 0 8 -40 62 -92 122 -4 6 -16 2 -28 -9 -20 -19
-47 -15 -126 15 -12 5 -86 16 -164 26 -126 16 -155 16 -244 5 -172 -23 -225
-24 -426 -7 -328 27 -597 45 -770 52 -340 14 -185 23 443 26 505 2 664 0 715
-10 37 -7 142 -16 234 -19 142 -4 176 -2 223 12 30 10 55 22 55 26 0 5 5 9 11
9 17 0 98 -62 104 -79 3 -9 23 -45 44 -80 l40 -64 6 36 c8 39 -14 81 -47 92
-27 9 -23 37 5 33 19 -3 22 1 19 24 -3 22 21 88 32 88 2 0 13 -27 25 -60z
m232 -11 c44 -31 239 -38 429 -14 169 21 175 21 895 16 538 -3 630 -12 290
-26 -93 -3 -285 -16 -425 -27 -375 -29 -459 -31 -625 -15 -226 21 -366 6 -528
-55 -83 -32 -106 -31 -146 2 -30 25 -23 56 23 104 39 42 48 43 87 15z m3125
-8 c61 -37 85 -151 44 -204 -30 -38 -80 -52 -123 -33 -38 16 -62 46 -82 103
-36 105 67 191 161 134z m-6631 -24 c69 -38 73 -114 8 -146 -32 -16 -32 -17
-26 -73 5 -46 3 -58 -8 -58 -29 0 -38 17 -41 75 -3 52 -6 60 -24 63 -17 2 -24
-6 -38 -41 -14 -36 -21 -44 -36 -40 -11 3 -20 10 -20 16 0 6 21 61 48 124 53
127 52 126 137 80z m6402 -64 c74 -173 90 -213 85 -218 -3 -3 -13 -5 -21 -5
-22 0 -125 231 -108 242 21 13 32 9 44 -19z m-85 -50 c23 -20 30 -57 17 -90
-10 -26 -8 -31 37 -70 27 -24 43 -43 37 -43 -6 0 -18 -3 -26 -6 -9 -3 -31 9
-55 30 -64 58 -88 46 -56 -29 13 -31 13 -39 2 -46 -7 -5 -17 -7 -22 -6 -8 3
-106 223 -106 238 0 4 8 9 18 12 9 3 35 12 57 21 42 16 69 13 97 -11z m-5989
-15 c28 -15 46 -38 47 -60 0 -26 -29 -22 -52 7 -22 29 -63 33 -72 8 -5 -12 6
-29 38 -59 36 -33 46 -49 46 -73 0 -39 -38 -81 -73 -81 -59 0 -117 42 -117 85
0 24 36 18 54 -9 19 -30 52 -42 71 -26 23 19 18 40 -19 74 -58 54 -65 85 -28
129 17 20 72 23 105 5z m-2268 -38 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6
2 10 4 10 3 0 8 -4 11 -10z m8064 -39 c37 -51 25 -102 -30 -126 -43 -20 -46
-29 -25 -80 14 -32 13 -35 -5 -40 -11 -4 -22 -5 -24 -3 -6 6 -95 241 -93 243
14 14 81 34 115 34 35 1 45 -4 62 -28z m-5584 -4 c16 -13 17 -25 12 -147 -3
-73 -8 -135 -11 -137 -13 -14 -41 19 -41 48 0 29 -4 34 -43 47 -41 13 -45 13
-66 -7 -23 -22 -56 -28 -56 -11 0 11 171 220 180 220 4 0 14 -6 25 -13z m287
-120 c-4 -14 -10 -17 -31 -12 -14 4 -30 7 -35 8 -5 1 -25 -44 -45 -100 -25
-73 -40 -103 -52 -103 -8 0 -18 3 -21 6 -4 3 10 53 29 111 37 110 36 122 -9
123 -17 0 -25 29 -12 42 3 3 45 -8 93 -25 74 -26 87 -34 83 -50z m4975 47 c7
-19 -8 -30 -60 -45 -36 -9 -38 -13 -32 -37 9 -37 9 -37 55 -23 22 6 45 9 50 6
22 -13 8 -35 -30 -46 -42 -13 -46 -21 -30 -63 l9 -26 51 20 c53 21 73 19 68
-7 -5 -22 -158 -74 -158 -53 0 6 -19 60 -41 121 -23 60 -39 113 -35 116 6 7
124 51 139 52 4 1 10 -6 14 -15z m2573 12 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1
-10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-1 -39 c-2 -1 -13 -9 -24 -17 -19 -14
-19 -14 -6 3 7 9 18 17 24 17 6 0 8 -1 6 -3z m-7471 -26 c21 -13 -55 -251 -79
-251 -10 0 -20 3 -23 8 -4 7 58 224 70 243 6 11 15 11 32 0z m4715 -10 c3 -15
-3 -23 -27 -32 -17 -7 -32 -13 -34 -14 -1 -1 7 -28 19 -61 43 -124 49 -155 33
-161 -22 -8 -28 2 -64 110 -32 96 -34 98 -59 92 -44 -11 -45 -11 -49 11 -2 18
8 24 80 46 46 14 86 26 89 27 4 1 9 -8 12 -18z m2537 -11 c0 -5 -5 -10 -11
-10 -5 0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z m-7069 -33 c19 -12 35
-30 37 -40 5 -23 -28 -35 -40 -14 -13 24 -46 39 -68 32 -33 -11 -23 -42 24
-74 64 -44 75 -93 31 -136 -30 -31 -75 -33 -120 -5 -31 19 -59 62 -48 74 14
13 42 5 48 -15 13 -39 95 -49 95 -11 0 9 -22 38 -50 64 -54 51 -62 81 -32 115
34 39 75 42 123 10z m4343 -127 c42 -60 76 -113 76 -119 0 -21 -36 -16 -56 7
-18 22 -24 24 -59 16 -32 -8 -40 -15 -50 -44 -6 -19 -19 -36 -29 -38 -15 -3
-16 7 -10 130 5 103 10 136 22 146 9 6 19 12 23 12 4 0 42 -49 83 -110z
m-4092 60 c5 0 8 -9 8 -20 0 -23 -16 -25 -71 -8 -45 13 -47 12 -55 -29 -6 -30
-5 -31 40 -37 48 -7 52 -11 37 -35 -7 -11 -17 -12 -52 -3 -24 6 -44 10 -45 9
-1 -1 -9 -24 -17 -52 -10 -38 -19 -51 -35 -53 -13 -2 -22 2 -22 9 0 14 60 240
66 251 2 3 35 -2 72 -13 37 -10 70 -19 74 -19z m6748 30 c0 -5 -7 -10 -16 -10
-8 0 -12 5 -9 10 3 6 10 10 16 10 5 0 9 -4 9 -10z m140 -4 c0 -3 -4 -8 -10
-11 -5 -3 -10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-3002 -138 c18 -62
36 -121 39 -130 4 -14 0 -18 -20 -18 -22 0 -27 7 -42 68 -26 98 -34 106 -35
36 0 -79 -9 -124 -25 -124 -7 0 -33 33 -59 72 -49 78 -54 75 -31 -12 20 -73
19 -90 -3 -90 -15 0 -23 20 -45 108 -15 59 -30 117 -33 128 -4 17 0 22 20 26
29 6 45 -9 97 -92 l34 -55 7 45 c3 25 7 66 7 92 1 46 6 52 46 57 6 0 25 -50
43 -111z m2957 92 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z
m-9866 -118 c51 -37 159 -111 240 -164 80 -54 141 -98 135 -98 -14 0 -246 138
-328 195 -35 25 -94 75 -132 111 -38 36 -55 56 -39 45 17 -12 72 -52 124 -89z
m3178 94 c3 -3 33 -235 33 -257 0 -15 -6 -20 -22 -17 -18 2 -24 11 -26 35 -3
25 -9 34 -34 42 -47 17 -65 13 -87 -15 -17 -21 -25 -25 -41 -18 -18 8 -14 17
58 126 64 98 80 116 97 111 11 -3 21 -6 22 -7z m3440 -131 c31 -131 33 -158
10 -163 -20 -4 -17 -11 -52 136 -26 114 -26 136 3 130 11 -2 22 -33 39 -103z
m-3174 79 c30 -7 57 -38 57 -66 0 -26 -29 -22 -52 7 -28 36 -80 35 -107 -4
-32 -45 -37 -101 -11 -134 24 -30 55 -35 87 -12 23 16 53 11 53 -10 0 -18 -43
-44 -77 -47 -43 -3 -92 21 -108 53 -20 38 -19 110 2 153 17 38 85 80 113 71 8
-2 27 -7 43 -11z m3072 -13 c0 -8 -13 -19 -30 -24 -16 -5 -31 -11 -33 -12 -2
-2 4 -40 14 -86 29 -149 29 -139 2 -139 -21 0 -25 6 -37 70 -7 38 -17 86 -22
106 -10 34 -13 36 -45 32 -27 -3 -38 0 -45 14 -12 21 -10 22 81 42 78 17 115
16 115 -3z m3368 -29 c-196 -160 -305 -230 -563 -365 -63 -33 -126 -67 -140
-77 -14 -9 -88 -50 -165 -91 -196 -102 -212 -112 -208 -126 4 -12 -13 -18 -47
-15 -14 1 -66 -18 -155 -59 -65 -29 -118 -49 -121 -46 -7 6 223 125 549 282
130 63 294 151 365 195 213 134 373 239 452 296 92 67 111 70 33 6z m-6242 2
c97 -18 100 -20 92 -40 -4 -11 -16 -14 -42 -12 l-36 3 -18 -105 c-10 -58 -22
-109 -26 -113 -13 -14 -41 4 -40 27 0 11 8 59 19 106 19 89 18 100 -6 100 -27
0 -54 20 -48 35 7 18 4 18 105 -1z m2590 -85 c5 -35 15 -81 20 -103 10 -38 11
-39 53 -33 23 3 50 9 59 13 13 5 17 1 17 -20 0 -19 -6 -27 -22 -30 -13 -3 -47
-10 -76 -17 -29 -6 -56 -9 -59 -5 -3 3 -14 54 -24 113 -10 60 -21 118 -24 130
-3 15 0 23 12 26 27 6 33 -4 44 -74z m-2417 53 c3 -4 -5 -68 -16 -140 -20
-126 -22 -132 -42 -126 -11 4 -23 8 -25 10 -2 1 6 59 18 127 12 69 21 128 21
131 0 9 38 7 44 -2z m2319 -89 c17 -113 10 -151 -32 -176 -37 -22 -100 -22
-129 1 -18 14 -26 38 -42 127 -11 60 -18 110 -17 111 1 1 12 5 24 8 25 8 29 0
38 -94 8 -84 22 -119 50 -126 30 -8 64 11 70 39 2 12 -1 60 -9 107 -7 47 -11
88 -9 93 2 4 12 7 22 7 16 0 21 -15 34 -97z m-5125 -20 c119 -58 258 -126 307
-149 106 -51 100 -59 -7 -10 -104 47 -391 189 -468 230 -125 68 -47 35 168
-71z m3036 66 c99 -78 56 -243 -66 -256 -123 -13 -185 150 -92 242 30 30 41
35 83 35 34 0 56 -6 75 -21z m156 -9 c4 0 27 -39 51 -86 24 -47 46 -87 50 -90
4 -2 10 26 14 63 3 38 7 75 8 83 1 8 13 17 26 18 24 4 24 3 18 -60 -3 -34 -9
-96 -13 -135 -6 -71 -7 -73 -33 -73 -23 1 -32 12 -71 90 -24 50 -47 90 -51 90
-4 0 -10 -38 -14 -85 -7 -82 -8 -85 -32 -85 -24 0 -25 2 -19 43 3 23 8 76 11
117 9 107 13 123 31 116 9 -3 19 -6 24 -6z m1535 -25 c31 -30 32 -73 4 -109
l-21 -26 31 -42 c37 -51 38 -58 6 -58 -16 0 -31 10 -42 28 -30 46 -50 64 -69
60 -15 -3 -18 -12 -15 -56 2 -49 1 -52 -22 -52 -23 0 -24 4 -31 83 -4 45 -9
105 -13 134 -6 58 -6 59 95 62 44 1 57 -3 77 -24z m-231 -16 c10 -50 7 -188
-4 -210 -24 -44 -98 -61 -149 -34 -39 20 -50 54 -53 165 -3 89 -2 95 17 95 18
0 21 -10 30 -100 6 -55 14 -106 18 -112 11 -18 72 -16 86 1 8 9 12 49 11 108
-2 124 -3 118 19 118 13 0 20 -10 25 -31z m-921 15 c15 -5 15 -52 1 -211 -5
-58 -7 -63 -30 -63 l-24 0 6 128 c7 161 7 162 47 146z m226 -22 c33 -24 36
-39 11 -47 -14 -4 -28 -1 -39 9 -22 20 -55 21 -71 1 -19 -23 -6 -40 40 -54 72
-21 105 -71 84 -126 -9 -22 -57 -45 -94 -45 -63 0 -125 52 -92 76 14 10 21 9
38 -7 37 -35 112 -23 101 16 -2 6 -28 22 -59 37 -66 31 -83 56 -73 105 11 60
95 79 154 35z m368 9 c51 -24 73 -63 73 -131 0 -62 -22 -104 -66 -125 -96 -46
-184 19 -184 135 0 65 22 103 74 126 41 18 53 17 103 -5z m-5069 -439 c35 -31
69 -59 75 -62 7 -3 53 -32 102 -64 50 -32 106 -68 125 -79 44 -25 467 -237
473 -237 3 0 49 -21 103 -46 55 -25 158 -73 229 -106 72 -33 172 -80 224 -104
51 -24 95 -44 98 -44 2 0 52 -22 111 -49 59 -26 134 -60 167 -74 283 -121 609
-267 734 -330 57 -29 68 -36 42 -32 l-33 5 23 -20 c21 -17 22 -19 6 -20 -24 0
-11 -20 14 -20 10 0 19 -4 19 -10 0 -15 -18 -12 -79 14 -31 14 -128 55 -216
92 -88 36 -206 86 -262 110 -56 24 -104 44 -107 44 -2 0 -33 13 -68 29 -35 16
-112 50 -173 76 -60 26 -128 55 -150 66 -22 10 -92 41 -155 68 -454 194 -491
211 -465 222 30 12 35 10 28 -8 -4 -10 -2 -14 4 -10 12 8 84 -14 78 -23 -5 -9
75 -41 85 -35 5 3 19 -4 32 -16 21 -18 61 -37 121 -56 31 -10 19 28 -13 40
-16 6 -30 14 -30 18 0 4 23 -1 50 -12 86 -33 79 -20 -10 18 -47 20 -117 50
-155 68 -39 18 -86 35 -105 39 -35 7 -35 7 -10 -8 14 -9 35 -15 47 -16 12 0
25 -4 28 -10 10 -16 -47 -8 -80 12 -16 10 -51 28 -78 39 -59 27 -56 33 8 14
26 -8 50 -13 52 -11 3 2 -6 7 -19 11 -25 7 -31 9 -128 53 -36 16 -85 37 -110
46 -25 10 -61 25 -80 34 -19 9 -41 16 -47 15 -7 0 -11 2 -9 6 3 4 -20 19 -50
35 -30 16 -54 32 -54 37 0 5 -5 9 -11 9 -6 0 -45 20 -86 45 -40 25 -76 45 -78
45 -2 0 -35 21 -72 47 -100 69 -251 202 -313 274 l-55 64 80 -68 c44 -38 109
-94 143 -125z m9507 -78 c-11 -8 -28 -21 -38 -29 -9 -8 -20 -15 -23 -15 -3 0
-23 -13 -43 -28 -118 -93 -624 -349 -891 -452 -90 -35 -366 -148 -410 -168
-68 -31 -120 -51 -120 -47 0 3 42 25 93 49 285 137 363 173 467 221 63 29 149
68 190 88 41 19 131 60 200 92 168 76 445 219 550 283 40 25 55 29 25 6z
m-8318 -85 c114 -48 323 -153 323 -161 0 -5 -3 -7 -7 -5 -5 2 -26 12 -48 22
-22 10 -89 42 -150 70 -153 72 -238 126 -118 74z m7993 -157 c0 -5 -11 -15
-25 -22 -32 -17 -26 -24 9 -10 33 12 52 4 35 -16 -7 -8 -22 -12 -38 -9 -23 5
-24 5 -4 -4 15 -7 35 -4 72 10 28 10 51 17 51 14 0 -2 -75 -42 -167 -88 -149
-75 -225 -110 -383 -179 -25 -11 -83 -37 -130 -58 -47 -21 -148 -65 -225 -98
-77 -34 -197 -86 -267 -117 -71 -30 -185 -80 -255 -110 -71 -31 -137 -60 -148
-65 -54 -24 -235 -100 -239 -100 -3 0 -30 -11 -60 -25 -59 -27 -70 -30 -62
-16 4 5 0 12 -6 14 -23 9 14 27 42 20 24 -5 24 -5 7 13 -15 16 -21 17 -49 6
-45 -17 -46 -8 -1 11 21 8 103 46 183 85 172 83 211 101 530 242 351 155 567
252 760 340 63 29 153 70 200 92 47 21 103 47 125 58 48 23 45 22 45 12z
m-7807 -26 c25 -19 22 -56 -4 -56 -30 0 -79 38 -72 55 6 19 52 19 76 1z m8177
-6 c0 -5 -7 -10 -16 -10 -8 0 -12 5 -9 10 3 6 10 10 16 10 5 0 9 -4 9 -10z
m-8940 -80 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4
10 -10z m117 -46 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-267
-24 c0 -5 8 -7 18 -4 16 5 16 5 0 -6 -10 -6 -29 -8 -45 -4 -25 7 -25 8 -8 15
28 11 35 10 35 -1z m324 -51 c5 -5 18 -3 28 2 11 6 24 9 31 6 7 -2 2 -9 -11
-16 -19 -10 -32 -9 -72 5 -26 9 -58 25 -71 36 -21 16 -17 15 31 -4 30 -12 59
-25 64 -29z m230 -54 c-5 -12 0 -14 25 -9 19 4 31 2 31 -4 0 -6 10 -12 23 -14
14 -2 21 -9 19 -20 -2 -12 8 -20 38 -28 22 -6 40 -15 40 -20 0 -5 -22 0 -50
12 -27 11 -50 27 -50 34 0 13 -13 18 -72 29 -37 6 -46 14 -31 28 12 13 32 7
27 -8z m1232 -130 c27 -14 60 -34 74 -44 l25 -20 -22 -20 c-38 -36 -132 -19
-146 26 -4 10 -12 25 -18 34 -16 21 -5 49 19 49 10 0 40 -11 68 -25z m4311 -2
c-9 -2 -15 -8 -12 -13 3 -4 -5 -6 -17 -2 -21 5 -21 6 -2 13 10 4 26 7 34 7 10
0 9 -2 -3 -5z m120 -109 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z
m-587 -112 c0 -12 -22 -32 -34 -32 -6 0 -4 5 4 10 13 9 13 11 0 20 -12 8 -11
10 8 10 12 0 22 -4 22 -8z m225 -72 c-3 -5 -10 -10 -16 -10 -5 0 -9 5 -9 10 0
6 7 10 16 10 8 0 12 -4 9 -10z m-325 -66 c0 -14 -3 -15 -17 -3 -10 7 -20 15
-22 16 -2 2 5 3 17 3 14 0 22 -6 22 -16z m-3430 -224 c8 -5 11 -10 5 -10 -5 0
-17 5 -25 10 -8 5 -10 10 -5 10 6 0 17 -5 25 -10z m2240 -841 c19 0 44 -4 54
-8 19 -7 18 -8 -3 -14 -29 -7 -126 10 -163 29 -41 21 -34 24 25 8 28 -7 68
-14 87 -15z"/>
<path d="M2355 9766 c-11 -7 -23 -14 -27 -15 -5 0 -8 -3 -8 -6 0 -3 0 -10 0
-17 0 -7 6 -5 18 4 9 9 27 19 40 22 24 8 30 26 9 26 -7 0 -21 -6 -32 -14z"/>
<path d="M2178 9663 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M9710 9340 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M9760 9320 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M10310 9075 c0 -7 61 -37 66 -33 2 3 -12 12 -31 21 -19 9 -35 15 -35
12z"/>
<path d="M10400 9026 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M11421 8055 c1 -19 18 -51 18 -35 0 8 -4 22 -9 30 -5 8 -9 11 -9 5z"/>
<path d="M4767 8643 c-4 -3 -7 -71 -7 -150 l0 -143 30 0 c89 0 150 64 150 157
0 68 -15 106 -49 126 -28 17 -111 24 -124 10z"/>
<path d="M5923 8500 c-26 -11 -45 -43 -37 -63 8 -21 50 -30 77 -16 29 16 37
28 37 62 0 23 -4 27 -27 26 -16 0 -38 -4 -50 -9z"/>
<path d="M6804 8595 c-22 -34 -30 -110 -14 -139 12 -24 49 -46 76 -46 8 0 26
11 39 25 21 20 25 34 25 82 0 77 -18 103 -70 103 -31 0 -43 -5 -56 -25z"/>
<path d="M5245 8460 c-47 -19 -57 -72 -16 -85 44 -14 103 40 88 79 -7 17 -39
20 -72 6z"/>
<path d="M8486 8424 c-30 -29 -15 -47 47 -60 69 -14 83 -1 50 44 -24 33 -73
41 -97 16z"/>
<path d="M3220 8103 c-41 -16 -70 -45 -70 -73 0 -35 22 -44 60 -25 37 19 48
38 42 76 -4 30 -7 31 -32 22z"/>
<path d="M9504 8188 c-49 -23 -61 -131 -19 -173 56 -57 115 -8 115 95 0 55
-53 97 -96 78z"/>
<path d="M2345 8038 c-64 -36 -96 -169 -61 -252 17 -41 28 -48 70 -48 74 0
126 70 126 170 0 70 -15 119 -40 132 -25 13 -70 12 -95 -2z"/>
<path d="M10235 7928 c-15 -22 -14 -24 26 -41 73 -31 89 -32 89 -8 0 30 -43
71 -74 71 -14 0 -31 -9 -41 -22z"/>
<path d="M6059 6824 c-11 -14 -14 -58 -14 -226 l0 -208 193 -3 193 -2 -3 217
c-3 198 -7 242 -24 226 -3 -4 -10 -67 -15 -142 -9 -139 -16 -162 -63 -209 -10
-11 -35 -21 -56 -24 -40 -6 -110 12 -110 28 0 6 -5 15 -10 22 -47 55 -47 56
-54 178 -4 66 -11 130 -15 141 -7 19 -8 19 -22 2z m208 -390 c-3 -3 -12 -4
-19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M3175 6820 c8 -13 285 -12 285 1 0 5 -66 9 -146 9 -98 0 -143 -3
-139 -10z"/>
<path d="M3893 6823 c26 -2 67 -2 90 0 23 2 2 3 -48 3 -49 0 -68 -1 -42 -3z"/>
<path d="M4096 6723 c-4 -60 -7 -231 -7 -382 0 -265 1 -275 23 -319 36 -72 64
-87 163 -87 97 0 124 14 165 86 l25 44 3 330 c2 182 1 354 -3 383 -11 91 -25
46 -25 -84 0 -76 -4 -124 -10 -124 -5 0 -10 5 -10 10 0 6 -13 4 -30 -5 -17 -9
-39 -13 -49 -10 -12 4 -21 -1 -26 -12 -7 -16 -9 -15 -15 7 -7 21 -8 18 -10
-20 l-3 -45 -8 45 c-4 25 -8 65 -8 90 -1 42 -7 51 -74 123 -39 42 -77 77 -83
77 -7 0 -14 -40 -18 -107z"/>
<path d="M3620 6760 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M5062 6274 l3 -327 104 2 c87 2 112 6 150 26 65 33 105 80 131 152
19 53 22 77 18 170 -3 97 -7 114 -33 162 -54 98 -143 141 -292 141 l-83 0 2
-326z"/>
<path d="M7966 6284 c3 -176 5 -325 4 -333 0 -11 17 -13 93 -8 117 7 167 21
216 64 106 90 137 310 64 452 -22 43 -42 65 -88 96 l-60 40 -117 4 -117 3 5
-318z"/>
<path d="M3306 6579 c-8 -23 -55 -184 -82 -277 -14 -48 -27 -95 -30 -104 -5
-17 5 -18 120 -18 83 0 126 4 126 11 0 14 -118 391 -125 397 -2 3 -7 -1 -9 -9z"/>
<path d="M7184 6533 c-9 -32 -23 -78 -31 -103 -8 -25 -26 -83 -39 -130 -14
-47 -27 -93 -30 -102 -5 -17 5 -18 120 -18 69 0 126 3 126 7 0 4 -11 43 -25
87 -14 45 -41 134 -61 199 -20 64 -38 117 -40 117 -2 0 -11 -26 -20 -57z"/>
<path d="M9020 6478 c-18 -62 -44 -147 -56 -188 -12 -41 -25 -83 -29 -92 -7
-17 3 -18 125 -18 101 0 131 3 128 13 -3 6 -20 59 -37 117 -18 58 -44 138 -57
179 -13 40 -24 80 -24 87 0 40 -20 2 -50 -98z"/>
<path d="M2124 6601 c-2 -2 -4 -67 -4 -143 l0 -138 138 0 c148 0 182 10 216
63 26 38 30 107 9 146 -33 63 -52 69 -211 73 -79 2 -146 1 -148 -1z"/>
<path d="M7913 5323 c43 -2 110 -2 150 0 40 1 5 3 -78 3 -82 0 -115 -2 -72 -3z"/>
<path d="M8168 5323 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3800 5261 c-62 -12 -127 -39 -177 -75 -38 -27 -159 -157 -256 -278
l-38 -46 28 -30 c15 -16 55 -58 88 -93 81 -86 171 -162 224 -189 105 -53 -54
-50 2612 -50 2748 0 2522 -6 2641 66 51 31 308 285 308 304 0 20 -244 280
-296 316 -123 85 -46 79 -964 81 -448 2 -950 -1 -1115 -5 l-300 -9 535 -2
c1178 -3 1672 -11 1724 -27 66 -21 125 -62 209 -148 120 -123 135 -156 21 -46
-127 123 -153 142 -231 172 l-58 23 -920 0 c-506 0 -1100 -2 -1320 -5 -220 -3
-904 -1 -1520 3 -820 7 -1137 6 -1182 -2 -113 -21 -148 -43 -278 -175 -66 -66
-106 -103 -90 -81 60 82 150 176 200 210 94 62 119 65 610 66 242 1 654 5 915
8 506 8 465 9 -625 16 -385 2 -720 0 -745 -4z m2007 -147 c29 -18 52 -41 60
-62 12 -30 12 -33 -9 -41 -13 -4 -40 -11 -60 -15 -30 -5 -38 -4 -38 7 0 16
-57 47 -87 47 -31 0 -64 -30 -61 -53 2 -18 18 -27 78 -45 173 -55 195 -73 195
-167 0 -73 -20 -104 -90 -136 -60 -28 -187 -26 -245 4 -49 24 -78 59 -82 97
-3 22 1 25 51 32 41 6 57 5 63 -4 4 -7 12 -19 17 -27 13 -19 106 -27 137 -11
28 16 32 55 7 69 -10 5 -47 16 -82 25 -142 36 -185 74 -183 163 1 100 81 156
215 149 53 -3 77 -9 114 -32z m373 -153 l0 -179 31 -26 c35 -30 67 -33 109
-11 17 9 31 17 32 18 1 1 4 85 7 187 l6 185 63 3 63 3 -3 -199 -3 -199 -29
-37 c-40 -53 -95 -76 -184 -76 -110 0 -165 28 -205 105 -16 32 -21 65 -25 176
-2 75 -2 157 2 183 l7 46 65 0 64 0 0 -179z m840 154 c71 -41 88 -134 35 -187
l-24 -25 30 -22 c68 -50 71 -137 7 -198 -44 -41 -102 -53 -257 -53 l-131 0 0
256 0 256 153 -4 c131 -3 157 -6 187 -23z m-3100 -127 c18 -59 45 -83 116
-102 27 -8 42 -16 34 -19 -121 -41 -135 -54 -160 -137 l-13 -45 -18 54 c-23
66 -50 97 -98 111 -20 7 -43 14 -51 17 -8 2 12 13 45 23 67 22 89 44 106 112
7 26 15 45 18 42 3 -3 12 -28 21 -56z m4793 -60 c7 -9 39 -25 70 -36 56 -18
65 -32 22 -32 -12 0 -40 -13 -63 -30 -32 -23 -44 -41 -58 -84 -10 -30 -21 -53
-25 -50 -4 2 -10 22 -14 45 -9 54 -58 102 -121 119 l-49 13 58 18 c74 22 92
38 107 97 19 70 22 71 42 12 10 -30 24 -63 31 -72z m-3498 -58 c0 -13 -64 -15
-504 -18 -495 -2 -554 1 -511 28 9 6 213 9 515 7 437 -2 500 -4 500 -17z
m3160 9 c4 -6 4 -13 0 -17 -9 -9 -1001 -9 -1010 0 -25 25 26 28 505 28 343 0
501 -3 505 -11z"/>
<path d="M6809 5036 c-2 -2 -3 -25 -1 -50 l4 -46 57 0 c46 0 62 4 77 21 17 19
17 23 3 47 -13 24 -21 27 -75 30 -33 2 -62 1 -65 -2z"/>
<path d="M6808 4795 c-4 -65 0 -68 89 -59 55 6 66 11 75 30 25 54 -17 84 -117
84 l-43 0 -4 -55z"/>
<path d="M5802 5253 c48 -2 129 -2 180 0 51 1 12 3 -87 3 -99 0 -141 -2 -93
-3z"/>
<path d="M6933 4463 c20 -2 54 -2 75 0 20 2 3 4 -38 4 -41 0 -58 -2 -37 -4z"/>
<path d="M7097 4463 c18 -2 50 -2 70 0 21 2 7 4 -32 4 -38 0 -55 -2 -38 -4z"/>
<path d="M4860 4154 c0 -33 33 -30 38 4 3 17 -2 22 -17 22 -16 0 -21 -6 -21
-26z"/>
<path d="M4836 4044 c-9 -24 22 -56 48 -48 31 10 31 12 6 39 -27 29 -45 32
-54 9z"/>
<path d="M5220 4135 c0 -32 2 -35 30 -35 23 0 31 5 36 24 8 34 -2 46 -37 46
-27 0 -29 -3 -29 -35z"/>
<path d="M5978 4091 c-17 -24 -11 -88 8 -95 36 -14 60 67 28 98 -19 20 -20 20
-36 -3z"/>
<path d="M6550 4085 c0 -75 2 -85 18 -85 36 0 54 25 60 79 5 59 -14 91 -55 91
-22 0 -23 -2 -23 -85z"/>
<path d="M6262 4098 c-19 -19 -14 -28 14 -28 18 0 25 5 22 17 -4 21 -21 26
-36 11z"/>
<path d="M6760 4025 c-10 -12 -10 -19 -2 -27 16 -16 42 -2 42 22 0 24 -22 26
-40 5z"/>
<path d="M7073 4033 c-17 -6 -16 -43 1 -43 18 0 39 27 31 40 -7 11 -13 11 -32
3z"/>
<path d="M8312 4098 c-18 -18 -14 -28 11 -28 30 0 40 10 26 27 -14 16 -22 16
-37 1z"/>
<path d="M4237 4033 c-10 -10 -8 -43 2 -43 23 0 41 14 41 31 0 19 -29 27 -43
12z"/>
<path d="M5432 4098 c-19 -19 -14 -28 14 -28 18 0 25 5 22 17 -4 21 -21 26
-36 11z"/>
<path d="M5793 4033 c-17 -6 -17 -43 0 -43 17 0 37 20 37 37 0 13 -15 16 -37
6z"/>
<path d="M7561 4097 c-14 -17 -4 -27 26 -27 25 0 29 10 11 28 -15 15 -23 15
-37 -1z"/>
<path d="M2493 3920 c-42 -17 -68 -104 -43 -150 12 -23 55 -34 81 -20 31 17
59 71 59 112 0 31 -5 40 -30 53 -33 17 -36 17 -67 5z"/>
<path d="M9778 3833 c-10 -2 -18 -11 -18 -19 0 -13 15 -50 25 -62 7 -8 55 24
61 40 11 36 -19 54 -68 41z"/>
<path d="M9550 3720 c-24 -24 -26 -60 -3 -103 20 -41 41 -56 74 -57 50 0 75
60 48 113 -34 65 -82 84 -119 47z"/>
<path d="M2956 3695 c-3 -13 -8 -30 -12 -38 -3 -10 5 -18 27 -26 41 -14 36
-15 55 14 19 30 9 48 -36 63 -25 9 -29 8 -34 -13z"/>
<path d="M9241 3591 c-11 -7 -11 -15 -1 -45 10 -31 15 -36 33 -30 36 10 50 30
43 58 -5 20 -13 26 -34 26 -15 0 -33 -4 -41 -9z"/>
<path d="M9043 3513 c-16 -6 -16 -25 -1 -58 25 -56 94 -9 72 49 -6 15 -44 20
-71 9z"/>
<path d="M3497 3428 c-16 -22 -27 -41 -25 -43 2 -2 15 -6 29 -10 25 -6 27 -4
31 37 3 24 2 46 -1 50 -3 3 -19 -12 -34 -34z"/>
<path d="M8370 3213 c0 -54 5 -59 42 -45 16 6 15 12 -12 52 l-30 45 0 -52z"/>
<path d="M4455 3140 c-29 -45 -27 -55 10 -62 24 -5 25 -3 25 48 0 30 -2 54 -5
54 -3 0 -16 -18 -30 -40z"/>
<path d="M5267 3032 c-61 -68 -38 -172 38 -172 58 0 82 40 77 125 -4 56 -79
87 -115 47z"/>
<path d="M6967 3013 c-16 -4 -18 -11 -12 -41 4 -21 8 -38 10 -40 2 -2 19 0 39
3 27 6 38 13 42 31 11 43 -21 62 -79 47z"/>
<path d="M6415 2965 c-54 -53 -20 -165 49 -165 44 0 68 29 73 87 4 41 1 52
-21 76 -31 34 -69 35 -101 2z"/>
<path d="M8872 1453 c-40 -14 -49 -33 -16 -33 8 0 13 4 9 9 -3 6 10 13 30 17
19 3 35 10 35 15 0 11 -4 10 -58 -8z"/>
<path d="M8800 1390 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M7475 10620 c-16 -7 -17 -9 -3 -9 9 -1 20 4 23 9 7 11 7 11 -20 0z"/>
<path d="M7657 10585 c-38 -25 -71 -45 -73 -45 -10 0 -154 -94 -149 -98 5 -5
240 134 285 168 48 37 5 20 -63 -25z"/>
<path d="M4890 10610 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7710 10578 c-36 -23 -89 -57 -118 -76 -29 -19 -77 -48 -107 -65
-153 -91 -167 -100 -155 -107 7 -4 10 -13 6 -19 -5 -7 -1 -8 11 -3 68 28 401
216 424 239 12 12 21 73 11 73 -4 0 -36 -19 -72 -42z"/>
<path d="M7424 10584 c-18 -14 -18 -15 4 -4 12 6 22 13 22 15 0 8 -5 6 -26
-11z"/>
<path d="M6984 10558 l-19 -23 23 19 c21 18 27 26 19 26 -2 0 -12 -10 -23 -22z"/>
<path d="M5350 10555 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"/>
<path d="M5420 10530 c-8 -5 -12 -12 -9 -15 4 -3 12 1 19 10 14 17 11 19 -10
5z"/>
<path d="M4438 10523 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5440 10511 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"/>
<path d="M7692 10477 l-73 -42 6 -44 c5 -29 3 -41 -4 -36 -6 3 -11 19 -11 36
0 16 -3 29 -7 28 -5 0 -42 -19 -83 -42 l-75 -43 0 -87 c0 -54 4 -86 10 -83 61
26 64 31 72 86 4 30 6 60 5 67 -2 6 2 14 7 18 6 3 8 13 5 23 -5 15 -4 15 5 1
6 -10 7 -29 1 -55 -13 -52 -12 -97 0 -89 6 3 11 18 11 33 1 17 3 21 6 10 2
-10 10 -18 16 -18 25 0 36 17 39 60 l4 45 8 -32 c9 -36 17 -40 36 -18 7 8 16
12 21 9 5 -3 9 9 9 25 0 17 -4 31 -10 31 -5 0 -10 9 -10 20 0 23 -10 25 -30 8
-8 -7 -4 -1 9 15 26 29 54 37 45 12 -7 -17 14 -85 26 -85 10 0 30 56 23 64 -4
3 -1 6 5 6 7 0 12 -7 12 -16 0 -8 5 -12 10 -9 14 8 9 145 -5 144 -5 0 -43 -19
-83 -42z m63 -17 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z
m-259 -165 c-20 -15 -36 -19 -36 -10 0 5 38 23 50 24 3 0 -4 -6 -14 -14z"/>
<path d="M9114 10464 c3 -9 6 -23 6 -33 0 -12 8 -17 30 -16 24 0 30 4 30 22 0
16 -6 23 -19 23 -11 0 -23 5 -26 10 -10 16 -28 11 -21 -6z"/>
<path d="M8060 10459 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M7400 10430 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M9217 10419 c3 -10 9 -16 14 -13 13 8 11 21 -5 27 -10 4 -12 0 -9
-14z"/>
<path d="M4139 10400 c-118 -48 -463 -239 -559 -310 -252 -186 -324 -392 -173
-492 150 -100 303 -139 652 -169 154 -13 492 -8 621 10 41 5 122 15 180 22 58
6 108 13 113 16 4 2 -8 21 -28 42 l-35 37 -148 -18 c-170 -20 -520 -24 -669
-7 -261 29 -489 132 -547 246 -32 64 -15 176 35 235 l29 33 -30 -60 c-40 -80
-47 -124 -26 -179 39 -102 173 -185 371 -230 212 -49 623 -47 970 4 486 71
776 138 1251 289 263 84 665 243 650 258 -2 2 -50 -15 -107 -37 -689 -276
-1389 -457 -1974 -511 -169 -16 -592 -6 -715 16 -183 33 -333 105 -385 183
-37 57 -43 128 -16 185 59 122 222 253 488 394 57 30 103 57 103 59 0 5 2 6
-51 -16z"/>
<path d="M4855 10399 c-3 -8 3 -50 14 -94 11 -43 18 -81 16 -85 -2 -4 2 -7 10
-7 18 0 19 16 4 54 -6 15 -13 51 -16 78 -5 53 -18 79 -28 54z"/>
<path d="M5400 10390 c0 -5 4 -10 9 -10 5 0 13 -9 16 -21 4 -11 9 -18 11 -16
7 7 -18 57 -28 57 -4 0 -8 -4 -8 -10z"/>
<path d="M4170 10308 c-183 -113 -311 -234 -343 -323 -22 -64 -22 -79 5 -127
31 -55 116 -100 253 -135 108 -28 115 -28 400 -27 305 0 371 6 685 60 270 46
679 148 895 222 33 12 105 37 160 56 224 77 462 173 435 176 -6 0 -158 -55
-265 -95 -200 -77 -672 -220 -880 -269 -201 -46 -438 -87 -645 -111 -161 -19
-491 -19 -634 0 -301 40 -420 147 -332 298 45 76 142 158 328 278 34 21 51 49
30 49 -4 0 -46 -24 -92 -52z"/>
<path d="M9126 10352 c-4 -3 -6 -17 -6 -32 0 -37 -34 -134 -61 -173 -32 -46
-151 -167 -165 -167 -7 0 -14 -4 -16 -9 -11 -30 -247 -157 -389 -209 -104 -37
-158 -61 -142 -62 6 0 23 4 38 10 14 5 24 6 21 1 -3 -5 -85 -34 -181 -66 -97
-31 -188 -63 -203 -71 -25 -13 -25 -14 -5 -14 25 0 39 -16 21 -23 -7 -2 -10
-8 -6 -12 18 -20 341 76 543 161 222 93 357 177 474 295 82 83 146 200 157
286 l6 51 -40 20 c-23 11 -43 17 -46 14z"/>
<path d="M7368 10289 c-31 -20 -45 -35 -41 -45 3 -7 12 -14 20 -14 12 0 12 -2
-1 -15 -8 -8 -20 -15 -26 -15 -26 0 -38 -27 -33 -69 5 -36 9 -42 27 -39 18 3
21 9 20 48 -1 43 3 41 20 -12 5 -17 7 -17 35 0 16 9 32 26 35 37 9 30 7 155
-1 154 -5 0 -29 -14 -55 -30z"/>
<path d="M6525 10247 c-16 -5 -43 -15 -60 -22 -16 -7 -56 -22 -87 -35 -54 -21
-75 -40 -45 -40 6 0 1 -9 -13 -20 -14 -11 -22 -20 -19 -20 7 0 146 54 184 71
11 5 52 22 90 38 52 23 63 30 43 31 -15 0 -30 -4 -33 -10 -3 -5 -16 -10 -28
-10 -20 0 -20 0 -1 15 22 17 12 17 -31 2z m-18 -33 c-3 -3 -12 -4 -19 -1 -8 3
-5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M7289 10248 c-7 -25 -5 -36 6 -31 8 2 11 11 8 19 -5 12 -12 18 -14
12z"/>
<path d="M7716 10217 c5 -33 2 -45 -31 -93 -20 -31 -34 -58 -32 -61 4 -3 27 7
56 25 3 1 6 15 7 30 2 15 7 42 13 61 8 26 7 38 -5 55 -14 20 -15 19 -8 -17z"/>
<path d="M7761 10210 c-7 -23 -10 -44 -8 -47 7 -6 29 65 25 79 -2 6 -10 -8
-17 -32z"/>
<path d="M7638 10195 c-18 -18 -27 -40 -32 -81 -4 -31 -5 -59 -2 -61 7 -7 76
88 82 114 7 26 -1 53 -14 53 -5 0 -21 -11 -34 -25z"/>
<path d="M4860 10185 c-12 -14 -5 -74 7 -61 6 6 14 76 9 76 -2 0 -9 -7 -16
-15z"/>
<path d="M7244 10144 c3 -9 6 -27 6 -40 0 -15 6 -24 15 -24 8 0 15 6 15 14 0
25 -19 66 -31 66 -6 0 -8 -7 -5 -16z"/>
<path d="M7588 10154 c-5 -4 -8 -16 -8 -28 0 -14 3 -17 11 -9 6 6 9 19 7 28
-1 9 -6 13 -10 9z"/>
<path d="M7520 10105 c-19 -12 -38 -21 -42 -18 -9 5 -9 -39 1 -80 l6 -28 33
28 c18 15 34 38 37 51 2 12 7 27 10 32 3 5 2 16 -2 24 -7 11 -14 9 -43 -9z"/>
<path d="M6869 10118 c-6 -22 -5 -38 3 -38 6 0 8 6 5 14 -3 8 -1 17 6 20 9 3
9 5 0 5 -7 1 -13 0 -14 -1z"/>
<path d="M6790 10086 c-28 -11 -34 -18 -32 -37 3 -32 5 -32 46 -13 27 13 35
23 34 41 -3 26 -1 26 -48 9z"/>
<path d="M7221 10074 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M4881 10044 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M7414 10022 c-10 -20 -22 -39 -26 -42 -4 -3 -3 -12 2 -20 8 -13 10
-13 10 1 0 24 28 31 39 11 8 -13 10 -6 11 30 0 60 -12 67 -36 20z"/>
<path d="M6874 10039 c-3 -6 -2 -15 3 -20 5 -5 9 -1 9 11 0 23 -2 24 -12 9z"/>
<path d="M7670 10029 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0
-10 -5 -10 -11z"/>
<path d="M7360 10016 c0 -8 -3 -23 -6 -33 -5 -16 -4 -16 10 1 18 22 21 46 6
46 -5 0 -10 -6 -10 -14z"/>
<path d="M6830 9970 c-8 -5 -11 -12 -7 -16 4 -4 13 -2 19 4 15 15 7 24 -12 12z"/>
<path d="M6888 9969 c-6 -17 27 -55 36 -40 4 5 0 13 -7 18 -8 4 -16 15 -19 22
-4 13 -5 13 -10 0z"/>
<path d="M7416 9971 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
<path d="M7306 9947 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M7260 9931 c0 -5 7 -11 14 -14 10 -4 13 -1 9 9 -6 15 -23 19 -23 5z"/>
<path d="M7240 9870 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M7227 9809 c4 -13 8 -18 11 -10 2 7 -1 18 -6 23 -8 8 -9 4 -5 -13z"/>
<path d="M8118 9803 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7201 9734 c-7 -16 -17 -37 -22 -46 -12 -23 -11 -38 0 -38 5 0 13 15
16 33 4 17 12 35 17 38 6 4 8 14 6 24 -2 14 -6 12 -17 -11z"/>
<path d="M8286 9691 c-3 -4 6 -6 19 -3 14 2 25 6 25 8 0 8 -39 4 -44 -5z"/>
<path d="M8248 9673 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4991 9569 c-30 -5 -56 -11 -57 -12 -2 -2 12 -19 30 -40 l32 -37 92
17 c51 9 92 19 92 22 0 13 -92 61 -113 60 -12 -1 -46 -5 -76 -10z"/>
<path d="M7280 9331 c-7 -15 -7 -21 0 -21 12 0 25 28 17 36 -3 3 -10 -4 -17
-15z"/>
<path d="M7300 9210 l-55 -29 35 -1 c19 -1 64 -3 100 -5 36 -2 58 -2 49 1 -11
3 -15 12 -11 26 5 22 -12 38 -43 37 -11 0 -45 -13 -75 -29z"/>
<path d="M8388 8943 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M11830 8241 c0 -56 -4 -101 -10 -103 -16 -5 -23 -733 -15 -1630 6
-710 10 -848 21 -848 12 0 14 208 14 1340 0 737 -2 1340 -5 1340 -3 0 -5 -45
-5 -99z"/>
<path d="M11657 8160 c-4 -30 -7 -280 -7 -555 1 -424 3 -503 15 -519 13 -17
15 -18 15 -3 0 24 27 21 35 -3 3 -11 9 -20 13 -21 4 0 17 -2 30 -5 l22 -4 -1
553 c-1 303 -5 541 -9 527 -4 -14 -8 -19 -9 -12 -2 27 -38 53 -64 47 -22 -6
-26 -3 -29 22 -2 20 -5 12 -11 -27z m30 -42 c-3 -8 -6 -5 -6 6 -1 11 2 17 5
13 3 -3 4 -12 1 -19z"/>
<path d="M887 8101 c-7 -31 -8 -33 -25 -19 -26 23 -72 29 -73 9 0 -12 -2 -11
-8 4 -19 46 -24 -188 -17 -765 4 -333 8 -615 8 -627 0 -32 6 -29 17 10 7 25 9
27 10 10 1 -18 7 -23 29 -23 20 0 32 7 40 23 10 20 11 20 11 -13 1 -26 4 -31
11 -20 6 10 10 -4 13 -45 2 -33 4 269 4 670 1 402 -2 750 -6 775 l-7 45 -7
-34z m0 -63 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m10 -905
c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m0 -80 c-3 -10 -5 -2
-5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z"/>
<path d="M10481 6453 c-24 -76 -51 -164 -62 -196 -10 -31 -19 -62 -19 -67 0
-6 49 -10 125 -10 l125 0 -6 28 c-6 27 -20 73 -68 230 -14 46 -28 98 -32 117
-3 19 -9 35 -13 35 -4 0 -27 -62 -50 -137z"/>
<path d="M1348 5783 c6 -2 12 -13 12 -23 0 -10 7 -31 14 -47 8 -15 18 -35 21
-43 14 -38 55 -94 55 -77 0 10 -11 30 -25 45 -14 15 -25 36 -25 48 0 12 -7 27
-15 34 -9 7 -12 16 -7 19 15 10 -6 51 -25 50 -11 0 -13 -3 -5 -6z"/>
<path d="M11016 5777 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z"/>
<path d="M1460 5577 c0 -4 5 -16 12 -26 10 -16 14 -17 25 -6 17 17 16 22 -1
28 -11 4 -13 1 -10 -11 5 -14 3 -13 -10 2 -9 11 -16 17 -16 13z"/>
<path d="M10990 5385 c-7 -9 -11 -18 -8 -20 3 -3 11 1 18 10 7 9 11 18 8 20
-3 3 -11 -1 -18 -10z"/>
<path d="M10895 5292 c-62 -59 -206 -177 -263 -216 -23 -16 -40 -31 -38 -34 5
-5 97 51 119 72 7 6 35 28 62 48 53 38 193 178 179 178 -5 0 -31 -22 -59 -48z"/>
<path d="M10550 5020 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M11771 4954 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M11664 4700 c0 -135 2 -190 3 -122 2 67 2 177 0 245 -1 67 -3 12 -3
-123z"/>
<path d="M11740 4846 c0 -8 5 -18 10 -21 6 -3 10 3 10 14 0 12 -4 21 -10 21
-5 0 -10 -6 -10 -14z"/>
<path d="M11770 4780 c0 -64 -3 -80 -15 -80 -8 0 -15 -9 -15 -20 0 -11 5 -20
10 -20 6 0 10 -9 10 -20 0 -11 -5 -20 -11 -20 -5 0 -7 -5 -3 -11 4 -8 9 -7 14
2 6 8 10 3 12 -17 2 -16 5 37 6 119 1 81 0 147 -3 147 -3 0 -5 -36 -5 -80z"/>
<path d="M11740 4766 c0 -8 5 -18 10 -21 6 -3 10 3 10 14 0 12 -4 21 -10 21
-5 0 -10 -6 -10 -14z"/>
<path d="M9520 4579 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M9675 4570 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M11773 4465 c0 -44 2 -61 4 -37 2 23 2 59 0 80 -2 20 -4 1 -4 -43z"/>
<path d="M2960 4496 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M3035 4460 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M11662 4280 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M11691 4064 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M11506 3783 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M810 3751 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z"/>
<path d="M11467 3713 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M11490 3694 c0 -10 28 -34 39 -34 6 0 2 9 -9 20 -20 20 -30 25 -30
14z"/>
<path d="M11435 3670 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3
0 -8 -4 -11 -10z"/>
<path d="M1139 3588 c0 -2 -3 -22 -5 -45 -5 -39 -3 -42 26 -48 18 -4 30 -13
31 -23 0 -11 2 -13 6 -4 3 7 -1 19 -8 28 -16 20 8 48 31 34 8 -5 11 -12 7 -17
-5 -4 -13 -1 -18 7 -9 13 -10 13 -6 0 2 -8 11 -14 19 -14 10 1 13 -6 10 -21
-5 -26 15 -42 31 -26 15 15 27 14 23 -1 -1 -7 -1 -10 1 -5 3 4 16 -2 30 -13
14 -11 30 -20 36 -20 5 0 -8 14 -29 31 -22 17 -61 53 -89 81 -27 28 -60 52
-72 54 -13 3 -23 3 -24 2z"/>
<path d="M1137 3468 c18 -17 35 -29 39 -26 8 9 -26 43 -51 52 -15 5 -12 -2 12
-26z"/>
<path d="M10960 3160 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M813 3115 c21 -53 33 -75 39 -75 5 0 2 12 -6 28 -17 30 -40 63 -33
47z"/>
<path d="M10310 2980 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M2637 2783 c-3 -5 9 -9 26 -10 26 -1 28 0 12 7 -26 11 -33 12 -38 3z"/>
<path d="M2687 2753 c-6 -10 126 -76 343 -171 74 -33 164 -73 200 -90 127 -60
386 -174 418 -186 17 -6 32 -14 32 -18 0 -5 4 -8 9 -8 23 0 261 -118 249 -124
-7 -3 -3 -3 9 0 14 3 43 -6 77 -24 l55 -29 -31 -14 -31 -15 52 0 c29 0 46 3
38 8 -16 10 2 9 28 -2 11 -5 14 -9 7 -9 -7 -1 -11 -5 -7 -10 3 -6 -7 -6 -27 0
-18 5 -34 9 -35 9 -1 0 2 -10 6 -22 5 -13 14 -22 20 -21 6 2 12 -2 12 -7 1 -6
2 -16 3 -22 0 -7 18 -14 39 -16 32 -3 37 -6 32 -23 -3 -10 -7 -28 -10 -38 -5
-15 6 -25 58 -50 35 -17 68 -31 74 -31 6 0 13 -5 15 -11 2 -6 15 -12 30 -12
14 -1 24 -5 23 -8 -2 -3 15 -14 38 -24 23 -10 49 -23 57 -30 8 -7 26 -16 40
-20 14 -4 32 -13 40 -20 8 -7 26 -16 40 -20 14 -4 61 -24 105 -45 44 -21 116
-54 160 -75 44 -20 103 -48 130 -62 79 -40 89 -42 103 -26 12 12 9 13 -15 8
-17 -4 -23 -3 -16 2 8 6 9 13 2 23 -7 13 -10 13 -18 1 -7 -11 -10 -11 -17 0
-4 7 -3 14 4 17 18 6 14 30 -5 35 -10 3 -3 5 15 6 17 0 31 4 30 9 -3 17 16 42
34 42 10 0 69 -24 131 -53 62 -30 130 -60 152 -67 22 -7 45 -16 50 -20 6 -4
44 -22 85 -40 41 -18 102 -44 135 -59 111 -51 145 -64 150 -59 3 3 -23 18 -57
33 -35 15 -130 61 -213 102 -139 69 -580 273 -590 273 -6 0 -520 233 -645 292
-47 22 -150 70 -230 105 -80 36 -172 78 -205 93 -33 15 -82 38 -110 50 -27 12
-142 65 -254 116 -112 52 -205 94 -208 94 -2 0 -55 25 -118 55 -62 30 -118 55
-124 55 -6 0 -11 5 -11 10 0 6 -5 10 -12 10 -6 0 -41 14 -77 32 -36 17 -77 31
-91 30 -17 -1 -21 1 -12 7 17 10 -103 65 -125 56 -9 -3 -20 -1 -23 6 -4 6 -10
7 -13 2z m1476 -698 c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z
m17 -35 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10
-10z m85 0 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0 13 -4 16 -10z m5 -30 c8
-5 11 -10 5 -10 -5 0 -17 5 -25 10 -8 5 -10 10 -5 10 6 0 17 -5 25 -10z m-11
-74 c10 -11 8 -16 -9 -21 -26 -8 -35 -1 -27 20 8 19 21 19 36 1z m26 -32 c-9
-9 -19 -13 -23 -10 -3 4 0 11 8 16 24 15 33 11 15 -6z m25 -24 c0 -5 -4 -10
-10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m107 -56 c-3 -3
-12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m590 -130 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m43 -24 c7 -14 7 -20 0 -20 -5 0 -10 6
-10 14 0 8 -6 17 -12 19 -10 4 -10 6 -1 6 7 1 17 -8 23 -19z"/>
<path d="M4018 2103 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M6950 2030 c-23 -7 -23 -8 -3 -9 12 -1 25 4 28 9 3 6 5 10 3 9 -2 -1
-14 -5 -28 -9z"/>
<path d="M4020 1975 c0 -4 60 -35 67 -35 2 0 2 4 -1 9 -6 9 -66 33 -66 26z"/>
<path d="M8305 1970 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M4120 1931 c0 -10 30 -24 37 -17 3 2 -5 9 -16 16 -12 6 -21 7 -21 1z"/>
<path d="M7280 1350 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
</g>
</svg>


    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
